import type { CurrentTempReading } from '$lib/State.svelte';

export const Paul3: CurrentTempReading[] = [
  [194.3, 194.1, null, 139.8],
  [194.8, 192.6, null, 139.1],
  [194.9, 190.4, null, 138.6],
  [194.3, 188.0, null, 138.3],
  [193.6, 185.5, null, 137.9],
  [192.8, 182.7, null, 137.6],
  [191.8, 179.9, null, 136.7],
  [190.5, 177.4, null, 136.7],
  [189.0, 174.2, null, 136.2],
  [187.3, 171.3, null, 135.8],
  [185.4, 168.4, null, 135.5],
  [183.5, 165.8, null, 134.8],
  [181.3, 162.9, null, 134.6],
  [179.1, 160.3, null, 134.1],
  [176.9, 157.8, null, 133.4],
  [174.6, 155.0, null, 133.2],
  [172.7, 152.5, null, 133.0],
  [170.5, 150.2, null, 132.5],
  [168.3, 147.7, null, 132.0],
  [165.8, 145.5, null, 131.5],
  [163.2, 143.3, null, 131.1],
  [161.4, 141.2, null, 130.6],
  [159.3, 138.8, null, 130.6],
  [156.9, 137.0, null, 130.4],
  [155.0, 135.3, null, 129.9],
  [153.1, 133.2, null, 129.4],
  [151.0, 131.5, null, 128.7],
  [148.9, 129.6, null, 128.5],
  [147.2, 128.4, null, 127.8],
  [145.3, 126.7, null, 127.1],
  [143.0, 125.2, null, 126.8],
  [141.1, 123.9, null, 126.4],
  [139.4, 122.4, null, 126.1],
  [137.5, 121.1, null, 125.9],
  [136.0, 119.9, null, 125.7],
  [134.2, 118.9, null, 125.0],
  [132.4, 117.8, null, 124.8],
  [130.6, 117.1, null, 124.1],
  [129.0, 116.2, null, 124.1],
  [127.6, 115.1, null, 123.6],
  [126.2, 114.7, null, 123.1],
  [124.6, 114.3, null, 122.4],
  [123.0, 113.5, null, 122.4],
  [121.8, 112.8, null, 121.9],
  [120.7, 112.3, null, 121.5],
  [119.1, 111.9, null, 121.2],
  [118.1, 111.8, null, 121.2],
  [116.3, 110.9, null, 119.8],
  [115.2, 110.7, null, 119.8],
  [114.1, 110.6, null, 119.4],
  [112.8, 110.6, null, 119.4],
  [111.9, 110.2, null, 118.6],
  [110.5, 110.0, null, 118.6],
  [109.5, 109.7, null, 118.2],
  [108.5, 109.5, null, 117.5],
  [107.4, 109.7, null, 117.5],
  [107.1, 109.3, null, 117.0],
  [105.8, 109.1, null, 116.6],
  [104.6, 109.6, null, 116.3],
  [104.1, 109.7, null, 116.3],
  [103.2, 109.7, null, 115.4],
  [102.1, 109.8, null, 115.6],
  [101.4, 109.7, null, 115.2],
  [100.5, 109.6, null, 114.5],
  [99.8, 109.7, null, 114.2],
  [99.2, 109.6, null, 114.0],
  [98.5, 109.6, null, 113.7],
  [97.6, 109.9, null, 113.0],
  [96.7, 109.9, null, 113.0],
  [96.9, 110.1, null, 113.0],
  [95.3, 110.1, null, 112.3],
  [94.7, 110.3, null, 112.3],
  [94.4, 110.6, null, 111.9],
  [93.9, 110.5, null, 111.9],
  [93.3, 110.6, null, 111.4],
  [92.7, 111.3, null, 111.2],
  [92.3, 111.1, null, 111.0],
  [91.7, 111.7, null, 110.7],
  [91.3, 111.4, null, 110.0],
  [90.8, 111.5, null, 109.8],
  [90.3, 112.1, null, 109.8],
  [90.0, 112.2, null, 109.8],
  [89.3, 112.2, null, 109.4],
  [89.1, 112.4, null, 109.1],
  [88.6, 112.6, null, 108.4],
  [88.2, 112.6, null, 108.2],
  [88.4, 112.9, null, 108.0],
  [87.6, 113.3, null, 107.7],
  [87.3, 113.4, null, 107.5],
  [87.3, 113.7, null, 107.1],
  [86.9, 113.9, null, 107.1],
  [86.4, 113.6, null, 106.6],
  [86.1, 114.3, null, 106.4],
  [85.9, 114.3, null, 106.4],
  [85.4, 114.4, null, 106.2],
  [85.5, 114.7, null, 105.9],
  [85.6, 114.9, null, 105.5],
  [84.8, 115.1, null, 105.3],
  [84.7, 115.2, null, 104.8],
  [84.4, 115.2, null, 105.0],
  [84.6, 115.2, null, 104.6],
  [84.2, 115.4, null, 104.1],
  [83.9, 115.6, null, 104.1],
  [83.9, 116.1, null, 104.1],
  [83.9, 116.1, null, 103.9],
  [83.5, 116.4, null, 104.1],
  [83.6, 116.6, null, 103.6],
  [83.2, 116.7, null, 103.2],
  [83.3, 117.0, null, 103.2],
  [82.9, 117.0, null, 103.2],
  [82.8, 117.2, null, 102.7],
  [82.8, 117.4, null, 102.2],
  [83.2, 117.2, null, 102.0],
  [82.9, 117.2, null, 102.0],
  [83.1, 117.6, null, 101.3],
  [82.6, 117.9, null, 101.3],
  [82.5, 118.0, null, 101.3],
  [82.6, 118.0, null, 101.3],
  [82.7, 118.3, null, 100.6],
  [82.5, 118.1, null, 100.6],
  [82.4, 118.3, null, 100.1],
  [82.2, 118.6, null, 100.1],
  [82.3, 118.9, null, 99.9],
  [82.4, 119.1, null, 99.9],
  [82.4, 119.3, null, 99.4],
  [82.4, 119.3, null, 99.0],
  [82.4, 119.7, null, 98.9],
  [82.5, 119.7, null, 98.5],
  [82.9, 120.0, null, 99.0],
  [82.5, 120.1, null, 98.5],
  [82.5, 120.2, null, 98.7],
  [82.8, 120.6, null, 98.3],
  [82.8, 120.5, null, 97.8],
  [82.5, 120.8, null, 98.0],
  [82.7, 121.0, null, 97.8],
  [82.8, 121.3, null, 97.3],
  [82.4, 121.1, null, 97.6],
  [83.1, 121.5, null, 97.8],
  [83.1, 123.2, null, 97.8],
  [83.0, 124.7, null, 97.8],
  [83.1, 126.5, null, 97.6],
  [83.5, 128.0, null, 98.0],
  [83.5, 129.5, null, 98.5],
  [83.7, 130.8, null, 98.7],
  [83.6, 132.5, null, 98.7],
  [84.2, 133.8, null, 98.3],
  [83.8, 135.6, null, 99.0],
  [84.3, 136.5, null, 99.2],
  [84.0, 138.0, null, 99.2],
  [84.3, 139.1, null, 99.0],
  [84.4, 140.0, null, 99.7],
  [84.4, 141.3, null, 99.7],
  [84.9, 142.2, null, 100.1],
  [84.8, 143.3, null, 100.1],
  [85.6, 143.5, null, 99.9],
  [85.7, 144.9, null, 100.4],
  [85.5, 145.6, null, 100.2],
  [85.8, 146.4, null, 100.2],
  [86.3, 147.0, null, 100.2],
  [86.4, 147.7, null, 100.6],
  [86.7, 149.1, null, 100.9],
  [87.0, 149.3, null, 100.9],
  [87.1, 150.3, null, 101.3],
  [87.1, 150.9, null, 101.1],
  [87.6, 151.4, null, 101.1],
  [88.0, 152.1, null, 101.6],
  [87.9, 152.7, null, 101.8],
  [88.3, 153.2, null, 101.8],
  [88.2, 153.8, null, 101.8],
  [88.7, 154.4, null, 102.0],
  [89.2, 154.7, null, 102.5],
  [89.2, 155.5, null, 102.5],
  [89.7, 156.2, null, 102.5],
  [89.7, 156.3, null, 102.7],
  [90.0, 157.0, null, 103.0],
  [90.3, 157.3, null, 102.7],
  [91.3, 158.1, null, 102.9],
  [90.8, 158.0, null, 103.2],
  [90.6, 159.1, null, 103.2],
  [91.3, 158.9, null, 103.4],
  [91.9, 159.7, null, 103.6],
  [92.1, 160.3, null, 103.2],
  [92.4, 160.5, null, 103.9],
  [92.4, 161.0, null, 103.9],
  [92.6, 161.4, null, 103.9],
  [92.9, 161.6, null, 104.5],
  [93.3, 162.1, null, 103.9],
  [93.6, 162.3, null, 104.3],
  [94.5, 162.8, null, 103.8],
  [94.3, 163.1, null, 104.1],
  [94.5, 163.4, null, 104.5],
  [94.9, 163.4, null, 104.5],
  [95.1, 163.5, null, 104.0],
  [95.3, 164.0, null, 104.5],
  [95.5, 164.4, null, 104.7],
  [96.1, 164.9, null, 104.7],
  [96.7, 165.1, null, 104.7],
  [96.8, 165.8, null, 105.0],
  [96.9, 165.6, null, 105.0],
  [97.7, 166.3, null, 105.0],
  [97.7, 166.5, null, 105.0],
  [98.0, 166.7, null, 105.2],
  [98.2, 167.3, null, 105.2],
  [98.8, 167.1, null, 105.0],
  [98.9, 167.2, null, 105.2],
  [99.2, 167.7, null, 105.2],
  [99.8, 168.0, null, 105.4],
  [100.1, 168.3, null, 105.4],
  [100.2, 168.6, null, 105.2],
  [100.0, 169.0, null, 105.7],
  [101.1, 169.5, null, 105.7],
  [100.9, 169.3, null, 105.2],
  [101.5, 169.9, null, 105.7],
  [102.0, 169.9, null, 105.7],
  [102.2, 170.3, null, 105.7],
  [102.3, 170.3, null, 105.7],
  [102.8, 171.0, null, 105.5],
  [103.0, 171.1, null, 105.5],
  [103.3, 171.6, null, 105.5],
  [103.7, 171.6, null, 105.5],
  [103.7, 171.7, null, 105.9],
  [103.6, 172.0, null, 105.7],
  [104.9, 172.4, null, 105.7],
  [105.4, 172.4, null, 105.9],
  [105.5, 172.8, null, 105.7],
  [105.6, 172.9, null, 105.7],
  [106.1, 173.1, null, 105.5],
  [106.5, 173.7, null, 106.0],
  [106.8, 174.0, null, 106.0],
  [107.1, 174.2, null, 106.0],
  [107.9, 174.4, null, 105.5],
  [107.8, 174.5, null, 106.0],
  [107.8, 174.7, null, 106.4],
  [108.5, 175.1, null, 106.0],
  [108.9, 175.0, null, 106.0],
  [109.1, 175.4, null, 106.2],
  [109.7, 175.5, null, 106.0],
  [109.9, 175.7, null, 105.7],
  [110.4, 176.1, null, 105.7],
  [110.8, 176.5, null, 106.2],
  [110.9, 176.8, null, 105.9],
  [111.3, 177.0, null, 106.2],
  [111.6, 176.9, null, 105.9],
  [111.7, 177.3, null, 106.0],
  [112.0, 177.9, null, 106.0],
  [112.2, 177.6, null, 106.0],
  [113.0, 178.1, null, 106.2],
  [113.0, 178.1, null, 105.9],
  [113.4, 178.6, null, 105.9],
  [113.9, 178.7, null, 105.7],
  [114.2, 179.2, null, 105.5],
  [114.6, 223.3, null, 105.7],
  [114.7, 179.3, null, 105.9],
  [115.1, 179.8, null, 106.2],
  [115.4, 179.8, null, 106.1],
  [115.9, 180.1, null, 105.7],
  [115.8, 180.4, null, 106.4],
  [116.4, 180.5, null, 107.1],
  [116.7, 180.8, null, 108.5],
  [116.9, 180.9, null, 109.6],
  [117.5, 180.9, null, 111.5],
  [117.4, 181.3, null, 114.0],
  [117.9, 181.5, null, 117.0],
  [118.5, 181.6, null, 121.0],
  [118.6, 182.1, null, 125.2],
  [119.0, 182.2, null, 130.6],
  [119.1, 182.1, null, 136.5],
  [119.6, 182.8, null, 143.5],
  [119.8, 182.6, null, 150.9],
  [120.2, 182.8, null, 158.9],
  [120.2, 183.2, null, 167.0],
  [120.8, 183.3, null, 174.9],
  [121.4, 183.3, null, 183.2],
  [121.5, 183.5, null, 191.8],
  [122.0, 183.7, null, 199.9],
  [122.3, 184.0, null, 207.3],
  [122.3, 184.1, null, 215.4],
  [122.8, 184.1, null, 222.8],
  [123.1, 184.3, null, 230.1],
  [123.4, 184.8, null, 236.7],
  [123.8, 184.8, null, 244.0],
  [124.2, 184.9, null, 250.4],
  [124.4, 185.0, null, 256.7],
  [124.6, 185.7, null, 262.5],
  [125.1, 185.7, null, 268.6],
  [125.2, 186.0, null, 274.4],
  [125.6, 186.3, null, 280.6],
  [125.9, 185.9, null, 285.7],
  [126.4, 186.5, null, 291.3],
  [126.5, 186.9, null, 296.8],
  [126.6, 187.1, null, 301.9],
  [127.1, 187.1, null, 306.5],
  [127.3, 187.4, null, 311.3],
  [127.9, 187.6, null, 315.9],
  [128.1, 187.7, null, 319.8],
  [128.2, 187.7, null, 324.6],
  [128.6, 187.9, null, 328.5],
  [128.8, 188.3, null, 331.9],
  [129.3, 188.3, null, 336.0],
  [129.3, 188.7, null, 340.1],
  [129.6, 189.0, null, 343.5],
  [130.2, 189.4, null, 347.6],
  [130.6, 189.3, null, 351.0],
  [130.9, 190.0, null, 353.8],
  [131.3, 189.7, null, 357.4],
  [131.2, 189.7, null, 360.3],
  [131.5, 190.0, null, 363.8],
  [132.0, 190.4, null, 366.7],
  [132.1, 190.3, null, 369.6],
  [132.6, 190.7, null, 372.6],
  [132.8, 190.7, null, 375.3],
  [132.9, 190.8, null, 377.8],
  [133.4, 191.1, null, 381.4],
  [133.5, 191.6, null, 387.1],
  [134.1, 191.6, null, 394.8],
  [134.3, 191.8, null, 403.4],
  [134.6, 191.9, null, 412.6],
  [134.8, 192.2, null, 422.3],
  [135.4, 192.5, null, 431.5],
  [135.6, 192.5, null, 441.0],
  [135.7, 192.6, null, 450.4],
  [136.2, 192.8, null, 458.9],
  [136.3, 192.8, null, 468.3],
  [136.7, 193.0, null, 476.6],
  [136.9, 193.2, null, 485.4],
  [137.2, 193.7, null, 493.4],
  [137.6, 193.8, null, 501.5],
  [138.0, 193.7, null, 509.3],
  [138.1, 194.0, null, 516.7],
  [138.1, 194.2, null, 524.1],
  [138.4, 194.4, null, 531.0],
  [138.8, 194.6, null, 537.9],
  [139.2, 194.7, null, 544.9],
  [139.6, 194.7, null, 551.8],
  [139.6, 194.9, null, 557.8],
  [140.2, 195.2, null, 564.5],
  [140.0, 195.6, null, 570.6],
  [140.4, 195.6, null, 576.2],
  [140.9, 195.9, null, 582.0],
  [141.2, 195.9, null, 587.8],
  [141.4, 196.6, null, 593.2],
  [141.7, 196.3, null, 598.6],
  [141.9, 196.7, null, 603.5],
  [142.3, 196.7, null, 608.6],
  [142.4, 197.1, null, 613.4],
  [142.7, 196.9, null, 618.3],
  [142.9, 197.2, null, 622.8],
  [143.4, 197.3, null, 627.3],
  [143.4, 197.7, null, 631.6],
  [143.7, 197.5, null, 635.6],
  [144.2, 197.8, null, 639.7],
  [144.2, 198.2, null, 643.7],
  [144.4, 198.4, null, 647.3],
  [145.1, 198.8, null, 651.4],
  [144.7, 198.8, null, 654.5],
  [145.2, 199.3, null, 658.4],
  [145.6, 199.3, null, 661.3],
  [145.7, 199.5, null, 664.5],
  [146.1, 199.5, null, 667.7],
  [146.3, 199.8, null, 670.8],
  [146.5, 200.0, null, 673.1],
  [146.9, 199.9, null, 674.9],
  [147.1, 200.0, null, 675.8],
  [147.1, 200.5, null, 675.8],
  [147.6, 200.4, null, 674.9],
  [147.9, 200.8, null, 673.5],
  [148.1, 200.9, null, 671.7],
  [148.9, 200.9, null, 669.7],
  [148.8, 201.2, null, 668.1],
  [149.2, 201.4, null, 666.1],
  [149.1, 201.5, null, 664.7],
  [149.6, 201.8, null, 664.3],
  [149.7, 201.8, null, 664.5],
  [149.5, 202.1, null, 664.5],
  [150.1, 202.6, null, 665.4],
  [150.5, 202.5, null, 665.6],
  [150.8, 202.7, null, 667.0],
  [151.0, 202.8, null, 667.9],
  [151.4, 203.3, null, 668.5],
  [151.7, 203.2, null, 669.4],
  [151.5, 203.5, null, 670.6],
  [152.0, 203.4, null, 670.8],
  [152.2, 203.7, null, 671.0],
  [152.7, 203.5, null, 671.0],
  [152.7, 203.9, null, 671.2],
  [153.1, 204.0, null, 670.8],
  [153.3, 204.3, null, 669.9],
  [153.5, 204.4, null, 670.1],
  [153.9, 204.4, null, 669.4],
  [153.9, 204.6, null, 669.0],
  [154.3, 204.8, null, 668.3],
  [154.6, 204.9, null, 668.1],
  [154.9, 205.0, null, 668.1],
  [155.0, 205.4, null, 667.6],
  [155.3, 205.5, null, 667.6],
  [155.7, 205.5, null, 667.6],
  [155.6, 205.3, null, 667.4],
  [156.0, 205.4, null, 667.4],
  [156.4, 205.1, null, 667.2],
  [156.5, 204.6, null, 667.2],
  [156.8, 204.7, null, 667.4],
  [156.7, 204.2, null, 667.7],
  [157.5, 204.0, null, 667.5],
  [157.7, 204.2, null, 667.9],
  [157.6, 204.0, null, 668.1],
  [158.0, 203.8, null, 668.1],
  [157.7, 204.0, null, 668.4],
  [158.3, 203.8, null, 668.8],
  [158.9, 203.6, null, 668.8],
  [159.0, 203.4, null, 669.5],
  [159.0, 203.4, null, 669.3],
  [159.4, 203.5, null, 669.7],
  [159.7, 203.4, null, 669.7],
  [159.8, 203.3, null, 669.5],
  [160.2, 203.3, null, 669.5],
  [160.0, 203.1, null, 670.4],
  [160.8, 203.1, null, 670.4],
  [160.6, 203.0, null, 670.6],
  [160.8, 203.5, null, 670.7],
  [161.1, 203.4, null, 670.6],
  [161.5, 203.3, null, 670.4],
  [161.7, 203.3, null, 670.6],
  [161.6, 203.3, null, 670.6],
  [162.1, 203.3, null, 670.6],
  [162.0, 203.3, null, 670.0],
  [162.3, 203.6, null, 670.0],
  [162.8, 203.5, null, 670.0],
  [162.9, 203.5, null, 669.7],
  [163.0, 203.5, null, 669.5],
  [163.0, 203.6, null, 669.7],
  [163.6, 203.7, null, 669.5],
  [163.5, 203.8, null, 669.9],
  [163.7, 203.8, null, 669.7],
  [164.1, 203.9, null, 669.7],
  [164.3, 203.8, null, 669.9],
  [164.2, 204.2, null, 669.9],
  [164.7, 204.2, null, 670.2],
  [164.6, 204.2, null, 669.7],
  [165.0, 204.1, null, 669.7],
  [165.2, 204.4, null, 669.9],
  [165.6, 204.5, null, 669.9],
  [165.9, 204.7, null, 670.4],
  [165.9, 204.6, null, 670.2],
  [165.8, 204.8, null, 670.9],
  [166.2, 205.0, null, 670.6],
  [166.5, 204.9, null, 670.6],
  [166.7, 204.9, null, 671.1],
  [166.9, 205.3, null, 671.1],
  [167.0, 205.4, null, 671.3],
  [167.0, 205.3, null, 671.0],
  [167.2, 205.6, null, 671.3],
  [167.6, 205.4, null, 671.3],
  [167.4, 205.3, null, 671.7],
  [168.2, 205.5, null, 671.9],
  [168.0, 205.9, null, 671.5],
  [168.3, 206.0, null, 671.7],
  [168.5, 206.0, null, 671.7],
  [168.6, 206.1, null, 671.7],
  [169.0, 206.2, null, 670.8],
  [169.2, 206.0, null, 671.3],
  [169.3, 206.7, null, 671.5],
  [169.4, 206.4, null, 670.8],
  [169.7, 206.6, null, 671.0],
  [169.8, 206.7, null, 670.8],
  [170.2, 206.9, null, 671.1],
  [170.0, 206.9, null, 670.8],
  [170.3, 207.0, null, 670.8],
  [170.6, 206.6, null, 670.8],
  [170.7, 206.9, null, 670.6],
  [171.0, 207.3, null, 670.6],
  [171.2, 207.2, null, 670.6],
  [171.2, 207.3, null, 670.8],
  [171.6, 207.4, null, 670.8],
  [171.8, 207.4, null, 670.6],
  [171.9, 207.3, null, 671.0],
  [172.0, 207.3, null, 670.6],
  [172.3, 207.4, null, 670.8],
  [172.5, 207.5, null, 670.8],
  [172.3, 207.7, null, 670.8],
  [172.6, 207.7, null, 670.6],
  [172.9, 207.6, null, 671.1],
  [173.1, 208.0, null, 670.8],
  [173.7, 207.9, null, 671.1],
  [173.4, 207.5, null, 670.9],
  [173.9, 207.6, null, 671.3],
  [173.9, 207.3, null, 671.1],
  [174.1, 207.2, null, 671.3],
  [174.2, 206.9, null, 671.3],
  [174.2, 207.1, null, 671.1],
  [174.6, 207.0, null, 671.3],
  [174.7, 206.8, null, 670.8],
  [174.9, 206.7, null, 670.8],
  [175.1, 206.7, null, 670.9],
  [175.3, 206.7, null, 670.9],
  [175.4, 206.5, null, 670.9],
  [175.3, 206.1, null, 671.3],
  [175.8, 206.3, null, 671.3],
  [175.9, 205.9, null, 671.3],
  [176.1, 206.1, null, 671.3],
  [176.2, 206.0, null, 671.3],
  [176.4, 205.8, null, 671.3],
  [176.6, 205.9, null, 671.5],
  [176.5, 206.0, null, 671.3],
  [176.6, 206.1, null, 671.5],
  [177.0, 205.8, null, 671.5],
  [177.2, 206.2, null, 671.5],
  [177.1, 206.0, null, 671.5],
  [177.2, 205.8, null, 672.0],
  [177.2, 206.0, null, 672.0],
  [177.8, 205.6, null, 671.7],
  [177.8, 206.0, null, 672.2],
  [177.8, 206.1, null, 672.2],
  [178.1, 206.1, null, 672.2],
  [178.3, 206.1, null, 672.2],
  [178.7, 206.2, null, 672.2],
  [178.6, 206.3, null, 672.2],
  [178.9, 206.4, null, 671.9],
  [178.9, 206.5, null, 672.4],
  [179.2, 206.4, null, 671.9],
  [179.4, 206.4, null, 672.4],
  [178.9, 206.5, null, 672.1],
  [179.5, 206.4, null, 672.1],
  [179.3, 206.6, null, 671.7],
  [179.7, 206.4, null, 671.9],
  [179.7, 206.3, null, 671.9],
  [180.1, 206.8, null, 671.4],
  [180.0, 206.4, null, 671.4],
  [180.2, 206.8, null, 671.4],
  [180.5, 206.5, null, 671.5],
  [180.5, 206.8, null, 671.7],
  [180.7, 206.8, null, 671.9],
  [180.9, 206.7, null, 671.5],
  [181.1, 207.0, null, 671.5],
  [180.9, 207.3, null, 671.9],
  [181.1, 207.1, null, 671.5],
  [181.4, 207.1, null, 671.5],
  [181.3, 207.2, null, 671.5],
  [181.8, 207.3, null, 671.2],
  [181.8, 207.3, null, 671.2],
  [182.0, 207.4, null, 671.0],
  [182.1, 207.4, null, 670.8],
  [182.3, 207.6, null, 671.0],
  [182.3, 207.4, null, 671.2],
  [182.6, 207.7, null, 671.5],
  [182.7, 207.6, null, 671.2],
  [182.7, 207.6, null, 671.5],
  [183.1, 207.8, null, 671.9],
  [183.2, 207.7, null, 672.1],
  [183.2, 207.9, null, 672.4],
  [183.5, 207.8, null, 672.8],
  [183.7, 208.1, null, 673.1],
  [183.8, 207.9, null, 673.5],
  [183.8, 207.9, null, 673.1],
  [183.8, 207.9, null, 673.1],
  [184.1, 207.8, null, 673.3],
  [184.1, 208.2, null, 672.9],
  [184.1, 208.4, null, 672.6],
  [184.2, 208.4, null, 672.2],
  [184.7, 208.1, null, 671.7],
  [185.0, 208.1, null, 671.3],
  [184.8, 208.4, null, 670.4],
  [184.7, 208.4, null, 670.1],
  [185.1, 208.5, null, 670.6],
  [185.0, 208.8, null, 670.1],
  [185.1, 208.7, null, 670.4],
  [185.5, 209.1, null, 670.8],
  [185.9, 208.9, null, 670.8],
  [185.8, 209.0, null, 670.8],
  [185.9, 209.1, null, 671.3],
  [186.0, 209.4, null, 671.7],
  [186.2, 209.4, null, 671.7],
  [186.3, 209.1, null, 672.6],
  [186.2, 209.5, null, 672.6],
  [186.4, 209.9, null, 672.8],
  [186.9, 209.7, null, 673.3],
  [187.0, 209.9, null, 673.5],
  [187.0, 209.9, null, 673.5],
  [187.1, 209.9, null, 673.3],
  [187.5, 210.0, null, 672.8],
  [187.2, 210.0, null, 673.0],
  [187.2, 210.5, null, 672.3],
  [187.6, 210.3, null, 671.9],
  [187.7, 210.4, null, 671.4],
  [187.7, 210.2, null, 671.0],
  [187.8, 210.3, null, 670.7],
  [188.2, 210.7, null, 670.5],
  [188.1, 210.6, null, 670.3],
  [188.4, 211.0, null, 671.0],
  [188.5, 211.0, null, 671.4],
  [188.5, 211.3, null, 672.1],
  [188.5, 211.3, null, 672.8],
  [189.1, 211.4, null, 673.2],
  [189.0, 211.5, null, 673.7],
  [189.1, 211.5, null, 674.4],
  [189.3, 211.4, null, 674.8],
  [189.4, 211.7, null, 675.1],
  [189.6, 211.6, null, 674.4],
  [189.4, 211.8, null, 674.1],
  [189.6, 211.6, null, 673.2],
  [190.1, 211.8, null, 672.3],
  [190.1, 211.6, null, 671.9],
  [190.3, 211.9, null, 671.0],
  [190.6, 212.1, null, 670.6],
  [190.7, 212.2, null, 670.1],
  [190.7, 211.9, null, 670.1],
  [190.9, 212.0, null, 670.1],
  [190.9, 212.0, null, 670.6],
  [190.9, 212.2, null, 670.3],
  [191.0, 212.2, null, 671.0],
  [191.1, 212.3, null, 671.0],
  [191.6, 212.3, null, 671.7],
  [191.7, 212.5, null, 672.2],
  [191.8, 212.8, null, 671.9],
  [191.9, 212.7, null, 672.6],
  [191.9, 212.6, null, 672.8],
  [192.2, 212.9, null, 673.5],
  [192.2, 212.9, null, 674.0],
  [192.8, 213.3, null, 673.5],
  [192.2, 213.3, null, 673.8],
  [193.0, 213.6, null, 674.0],
  [192.8, 213.4, null, 673.5],
  [192.9, 213.9, null, 673.1],
  [193.3, 213.7, null, 672.9],
  [193.4, 213.6, null, 672.4],
  [193.6, 213.8, null, 672.2],
  [193.5, 213.7, null, 671.7],
  [193.9, 214.1, null, 671.0],
  [194.1, 214.0, null, 671.5],
  [193.9, 214.3, null, 670.8],
  [193.7, 214.1, null, 670.8],
  [194.3, 214.2, null, 670.8],
  [194.6, 214.3, null, 670.8],
  [194.3, 214.5, null, 671.0],
  [194.4, 214.4, null, 671.3],
  [194.6, 214.6, null, 671.5],
  [194.9, 214.8, null, 671.5],
  [194.8, 215.0, null, 671.7],
  [195.3, 214.8, null, 672.2],
  [195.3, 215.0, null, 672.2],
  [195.7, 215.1, null, 672.2],
  [195.9, 215.2, null, 672.6],
  [195.8, 215.5, null, 672.4],
  [196.0, 215.4, null, 672.8],
  [196.1, 215.6, null, 673.3],
  [196.5, 215.6, null, 673.7],
  [196.6, 215.6, null, 673.5],
  [197.2, 215.9, null, 674.0],
  [196.6, 216.2, null, 673.8],
  [197.0, 216.3, null, 674.0],
  [196.6, 216.0, null, 673.7],
  [197.2, 216.1, null, 673.3],
  [197.2, 216.5, null, 673.5],
  [197.4, 216.1, null, 673.1],
  [197.9, 216.3, null, 672.8],
  [197.6, 216.5, null, 672.6],
  [197.8, 216.6, null, 672.6],
  [197.9, 216.8, null, 672.6],
  [198.0, 216.9, null, 672.4],
  [198.2, 217.1, null, 672.2],
  [198.5, 217.0, null, 671.5],
  [198.6, 216.8, null, 671.7],
  [198.8, 217.1, null, 671.7],
  [198.7, 217.2, null, 671.9],
  [198.9, 217.4, null, 671.9],
  [199.1, 217.1, null, 672.8],
  [199.2, 217.5, null, 672.6],
  [199.2, 217.2, null, 672.9],
  [199.0, 217.3, null, 673.5],
  [199.6, 217.0, null, 673.3],
  [199.7, 217.0, null, 673.5],
  [199.8, 217.0, null, 673.3],
  [200.2, 217.1, null, 673.8],
  [200.2, 217.1, null, 673.6],
  [200.5, 216.3, null, 673.6],
  [200.0, 215.7, null, 673.3],
  [200.4, 215.1, null, 673.1],
  [200.5, 214.7, null, 673.1],
  [200.7, 214.1, null, 672.7],
  [200.7, 213.5, null, 672.4],
  [201.2, 213.0, null, 672.4],
  [201.2, 212.9, null, 672.2],
  [201.2, 212.4, null, 672.0],
  [201.3, 212.1, null, 671.8],
  [201.2, 211.7, null, 671.5],
  [201.2, 211.4, null, 671.3],
  [201.2, 211.1, null, 671.1],
  [201.4, 210.6, null, 670.6],
  [201.7, 210.5, null, 670.9],
  [201.8, 210.2, null, 670.9],
  [201.8, 210.0, null, 671.3],
  [202.0, 209.9, null, 671.6],
  [202.0, 209.6, null, 671.8],
  [202.1, 209.4, null, 672.1],
  [202.0, 209.2, null, 672.3],
  [202.3, 209.0, null, 672.7],
  [202.4, 208.6, null, 673.4],
  [202.6, 208.6, null, 673.4],
  [202.8, 208.5, null, 673.6],
  [202.4, 208.4, null, 673.9],
  [202.8, 208.1, null, 673.9],
  [202.6, 208.1, null, 673.9],
  [202.9, 207.7, null, 673.9],
  [202.9, 207.6, null, 673.7],
  [202.7, 207.5, null, 673.4],
  [202.9, 207.4, null, 673.7],
  [202.9, 207.5, null, 673.0],
  [203.2, 206.9, null, 673.0],
  [202.9, 207.0, null, 672.3],
  [203.3, 207.2, null, 672.3],
  [203.2, 206.7, null, 672.1],
  [203.0, 207.0, null, 672.1],
  [203.4, 206.9, null, 671.6],
  [203.3, 206.6, null, 671.9],
  [203.7, 206.6, null, 671.9],
  [203.5, 206.5, null, 672.1],
  [203.2, 206.4, null, 672.5],
  [203.4, 206.4, null, 672.5],
  [203.5, 206.3, null, 672.7],
  [203.6, 206.1, null, 672.7],
  [203.6, 206.1, null, 673.2],
  [203.7, 205.7, null, 673.6],
  [203.9, 205.9, null, 673.4],
  [204.2, 206.0, null, 673.6],
  [203.6, 206.0, null, 674.1],
  [204.1, 205.8, null, 673.9],
  [203.9, 205.8, null, 673.9],
  [204.1, 205.5, null, 674.1],
  [204.1, 205.7, null, 673.2],
  [204.2, 205.6, null, 672.7],
  [204.2, 205.6, null, 672.0],
  [204.2, 205.5, null, 671.6],
  [204.0, 205.5, null, 671.4],
  [204.6, 205.5, null, 671.1],
  [204.3, 205.4, null, 670.9],
  [204.2, 205.6, null, 670.7],
  [204.2, 205.3, null, 671.1],
  [204.2, 205.1, null, 671.4],
  [204.5, 205.4, null, 672.1],
  [204.4, 205.2, null, 672.3],
  [204.6, 205.0, null, 672.5],
  [204.0, 204.9, null, 672.5],
  [204.7, 204.7, null, 673.4],
  [204.2, 204.6, null, 673.4],
  [204.5, 204.6, null, 673.2],
  [204.5, 204.6, null, 673.9],
  [204.5, 204.9, null, 673.9],
  [204.2, 204.8, null, 674.1],
  [204.5, 204.6, null, 673.9],
  [204.5, 204.5, null, 674.6],
  [204.3, 204.7, null, 674.3],
  [204.4, 204.5, null, 674.6],
  [204.5, 204.7, null, 674.1],
  [204.4, 204.6, null, 673.7],
  [204.7, 204.0, null, 673.4]
];

export const LINEAR: CurrentTempReading[] = [
  [100.0, 130.0, null, null],
  [100.5, 130.5, null, null],
  [101.0, 131.0, null, null],
  [101.5, 131.5, null, null],
  [102.0, 132.0, null, null],
  [102.5, 132.5, null, null],
  [103.0, 133.0, null, null],
  [103.5, 133.5, null, null],
  [104.0, 134.0, null, null],
  [104.5, 134.5, null, null],
  [105.0, 135.0, null, null],
  [105.5, 135.5, null, null],
  [106.0, 136.0, null, null],
  [106.5, 136.5, null, null],
  [107.0, 137.0, null, null],
  [107.5, 137.5, null, null],
  [108.0, 138.0, null, null],
  [108.5, 138.5, null, null],
  [109.0, 139.0, null, null],
  [109.5, 139.5, null, null],
  [110.0, 140.0, null, null],
  [110.5, 140.5, null, null],
  [111.0, 141.0, null, null],
  [111.5, 141.5, null, null],
  [112.0, 142.0, null, null],
  [112.5, 142.5, null, null],
  [113.0, 143.0, null, null],
  [113.5, 143.5, null, null],
  [114.0, 144.0, null, null],
  [114.5, 144.5, null, null],
  [115.0, 145.0, null, null],
  [115.5, 145.5, null, null],
  [116.0, 146.0, null, null],
  [116.5, 146.5, null, null],
  [117.0, 147.0, null, null],
  [117.5, 147.5, null, null],
  [118.0, 148.0, null, null],
  [118.5, 148.5, null, null],
  [119.0, 149.0, null, null],
  [119.5, 149.5, null, null],
  [120.0, 150.0, null, null],
  [120.5, 150.5, null, null],
  [121.0, 151.0, null, null],
  [121.5, 151.5, null, null],
  [122.0, 152.0, null, null],
  [122.5, 152.5, null, null],
  [123.0, 153.0, null, null],
  [123.5, 153.5, null, null],
  [124.0, 154.0, null, null],
  [124.5, 154.5, null, null],
  [125.0, 155.0, null, null],
  [125.5, 155.5, null, null],
  [126.0, 156.0, null, null],
  [126.5, 156.5, null, null],
  [127.0, 157.0, null, null],
  [127.5, 157.5, null, null],
  [128.0, 158.0, null, null],
  [128.5, 158.5, null, null],
  [129.0, 159.0, null, null],
  [129.5, 159.5, null, null],
  [130.0, 160.0, null, null],
  [130.5, 160.5, null, null],
  [131.0, 161.0, null, null],
  [131.5, 161.5, null, null],
  [132.0, 162.0, null, null],
  [132.5, 162.5, null, null],
  [133.0, 163.0, null, null],
  [133.5, 163.5, null, null],
  [134.0, 164.0, null, null],
  [134.5, 164.5, null, null],
  [135.0, 165.0, null, null],
  [135.5, 165.5, null, null],
  [136.0, 166.0, null, null],
  [136.5, 166.5, null, null],
  [137.0, 167.0, null, null],
  [137.5, 167.5, null, null],
  [138.0, 168.0, null, null],
  [138.5, 168.5, null, null],
  [139.0, 169.0, null, null],
  [139.5, 169.5, null, null],
  [140.0, 170.0, null, null],
  [140.5, 170.5, null, null],
  [141.0, 171.0, null, null],
  [141.5, 171.5, null, null],
  [142.0, 172.0, null, null],
  [142.5, 172.5, null, null],
  [143.0, 173.0, null, null],
  [143.5, 173.5, null, null],
  [144.0, 174.0, null, null],
  [144.5, 174.5, null, null],
  [145.0, 175.0, null, null],
  [145.5, 175.5, null, null],
  [146.0, 176.0, null, null],
  [146.5, 176.5, null, null],
  [147.0, 177.0, null, null],
  [147.5, 177.5, null, null],
  [148.0, 178.0, null, null],
  [148.5, 178.5, null, null],
  [149.0, 179.0, null, null],
  [149.5, 179.5, null, null],
  [150.0, 180.0, null, null],
  [150.5, 180.5, null, null],
  [151.0, 181.0, null, null],
  [151.5, 181.5, null, null],
  [152.0, 182.0, null, null],
  [152.5, 182.5, null, null],
  [153.0, 183.0, null, null],
  [153.5, 183.5, null, null],
  [154.0, 184.0, null, null],
  [154.5, 184.5, null, null],
  [155.0, 185.0, null, null],
  [155.5, 185.5, null, null],
  [156.0, 186.0, null, null],
  [156.5, 186.5, null, null],
  [157.0, 187.0, null, null],
  [157.5, 187.5, null, null],
  [158.0, 188.0, null, null],
  [158.5, 188.5, null, null],
  [159.0, 189.0, null, null],
  [159.5, 189.5, null, null],
  [160.0, 190.0, null, null],
  [160.5, 190.5, null, null],
  [161.0, 191.0, null, null],
  [161.5, 191.5, null, null],
  [162.0, 192.0, null, null],
  [162.5, 192.5, null, null],
  [163.0, 193.0, null, null],
  [163.5, 193.5, null, null],
  [164.0, 194.0, null, null],
  [164.5, 194.5, null, null],
  [165.0, 195.0, null, null],
  [165.5, 195.5, null, null],
  [166.0, 196.0, null, null],
  [166.5, 196.5, null, null],
  [167.0, 197.0, null, null],
  [167.5, 197.5, null, null],
  [168.0, 198.0, null, null],
  [168.5, 198.5, null, null],
  [169.0, 199.0, null, null],
  [169.5, 199.5, null, null],
  [170.0, 200.0, null, null],
  [170.5, 200.5, null, null],
  [171.0, 201.0, null, null],
  [171.5, 201.5, null, null],
  [172.0, 202.0, null, null],
  [172.5, 202.5, null, null],
  [173.0, 203.0, null, null],
  [173.5, 203.5, null, null],
  [174.0, 204.0, null, null],
  [174.5, 204.5, null, null],
  [175.0, 205.0, null, null],
  [175.5, 205.5, null, null],
  [176.0, 206.0, null, null],
  [176.5, 206.5, null, null],
  [177.0, 207.0, null, null],
  [177.5, 207.5, null, null],
  [178.0, 208.0, null, null],
  [178.5, 208.5, null, null],
  [179.0, 209.0, null, null],
  [179.5, 209.5, null, null],
  [180.0, 210.0, null, null],
  [180.5, 210.5, null, null],
  [181.0, 211.0, null, null],
  [181.5, 211.5, null, null],
  [182.0, 212.0, null, null],
  [182.5, 212.5, null, null],
  [183.0, 213.0, null, null],
  [183.5, 213.5, null, null],
  [184.0, 214.0, null, null],
  [184.5, 214.5, null, null],
  [185.0, 215.0, null, null],
  [185.5, 215.5, null, null],
  [186.0, 216.0, null, null],
  [186.5, 216.5, null, null],
  [187.0, 217.0, null, null],
  [187.5, 217.5, null, null],
  [188.0, 218.0, null, null],
  [188.5, 218.5, null, null],
  [189.0, 219.0, null, null],
  [189.5, 219.5, null, null],
  [190.0, 220.0, null, null],
  [190.5, 220.5, null, null],
  [191.0, 221.0, null, null],
  [191.5, 221.5, null, null],
  [192.0, 222.0, null, null],
  [192.5, 222.5, null, null],
  [193.0, 223.0, null, null],
  [193.5, 223.5, null, null],
  [194.0, 224.0, null, null],
  [194.5, 224.5, null, null],
  [195.0, 225.0, null, null],
  [195.5, 225.5, null, null],
  [196.0, 226.0, null, null],
  [196.5, 226.5, null, null],
  [197.0, 227.0, null, null],
  [197.5, 227.5, null, null],
  [198.0, 228.0, null, null],
  [198.5, 228.5, null, null],
  [199.0, 229.0, null, null],
  [199.5, 229.5, null, null],
  [200.0, 230.0, null, null],
  [200.5, 230.5, null, null],
  [201.0, 231.0, null, null],
  [201.5, 231.5, null, null],
  [202.0, 232.0, null, null],
  [202.5, 232.5, null, null],
  [203.0, 233.0, null, null],
  [203.5, 233.5, null, null],
  [204.0, 234.0, null, null],
  [204.5, 234.5, null, null],
  [205.0, 235.0, null, null],
  [205.5, 235.5, null, null],
  [206.0, 236.0, null, null],
  [206.5, 236.5, null, null],
  [207.0, 237.0, null, null],
  [207.5, 237.5, null, null],
  [208.0, 238.0, null, null],
  [208.5, 238.5, null, null],
  [209.0, 239.0, null, null],
  [209.5, 239.5, null, null],
  [210.0, 240.0, null, null],
  [210.5, 240.5, null, null],
  [211.0, 241.0, null, null],
  [211.5, 241.5, null, null],
  [212.0, 242.0, null, null],
  [212.5, 242.5, null, null],
  [213.0, 243.0, null, null],
  [213.5, 243.5, null, null],
  [214.0, 244.0, null, null],
  [214.5, 244.5, null, null],
  [215.0, 245.0, null, null],
  [215.5, 245.5, null, null],
  [216.0, 246.0, null, null],
  [216.5, 246.5, null, null],
  [217.0, 247.0, null, null],
  [217.5, 247.5, null, null],
  [218.0, 248.0, null, null],
  [218.5, 248.5, null, null],
  [219.0, 249.0, null, null],
  [219.5, 249.5, null, null],
  [220.0, 250.0, null, null],
  [220.5, 250.5, null, null],
  [221.0, 251.0, null, null],
  [221.5, 251.5, null, null],
  [222.0, 252.0, null, null],
  [222.5, 252.5, null, null],
  [223.0, 253.0, null, null],
  [223.5, 253.5, null, null],
  [224.0, 254.0, null, null],
  [224.5, 254.5, null, null],
  [225.0, 255.0, null, null],
  [225.5, 255.5, null, null],
  [226.0, 256.0, null, null],
  [226.5, 256.5, null, null],
  [227.0, 257.0, null, null],
  [227.5, 257.5, null, null],
  [228.0, 258.0, null, null],
  [228.5, 258.5, null, null],
  [229.0, 259.0, null, null],
  [229.5, 259.5, null, null],
  [230.0, 260.0, null, null],
  [230.5, 260.5, null, null],
  [231.0, 261.0, null, null],
  [231.5, 261.5, null, null],
  [232.0, 262.0, null, null],
  [232.5, 262.5, null, null],
  [233.0, 263.0, null, null],
  [233.5, 263.5, null, null],
  [234.0, 264.0, null, null],
  [234.5, 264.5, null, null],
  [235.0, 265.0, null, null],
  [235.5, 265.5, null, null],
  [236.0, 266.0, null, null],
  [236.5, 266.5, null, null],
  [237.0, 267.0, null, null],
  [237.5, 267.5, null, null],
  [238.0, 268.0, null, null],
  [238.5, 268.5, null, null],
  [239.0, 269.0, null, null],
  [239.5, 269.5, null, null],
  [240.0, 270.0, null, null],
  [240.5, 270.5, null, null],
  [241.0, 271.0, null, null],
  [241.5, 271.5, null, null],
  [242.0, 272.0, null, null],
  [242.5, 272.5, null, null],
  [243.0, 273.0, null, null],
  [243.5, 273.5, null, null],
  [244.0, 274.0, null, null],
  [244.5, 274.5, null, null],
  [245.0, 275.0, null, null],
  [245.5, 275.5, null, null],
  [246.0, 276.0, null, null],
  [246.5, 276.5, null, null],
  [247.0, 277.0, null, null],
  [247.5, 277.5, null, null],
  [248.0, 278.0, null, null],
  [248.5, 278.5, null, null],
  [249.0, 279.0, null, null],
  [249.5, 279.5, null, null],
  [250.0, 280.0, null, null],
  [250.5, 280.5, null, null],
  [251.0, 281.0, null, null],
  [251.5, 281.5, null, null],
  [252.0, 282.0, null, null],
  [252.5, 282.5, null, null],
  [253.0, 283.0, null, null],
  [253.5, 283.5, null, null],
  [254.0, 284.0, null, null],
  [254.5, 284.5, null, null],
  [255.0, 285.0, null, null],
  [255.5, 285.5, null, null],
  [256.0, 286.0, null, null],
  [256.5, 286.5, null, null],
  [257.0, 287.0, null, null],
  [257.5, 287.5, null, null],
  [258.0, 288.0, null, null],
  [258.5, 288.5, null, null],
  [259.0, 289.0, null, null],
  [259.5, 289.5, null, null],
  [260.0, 290.0, null, null],
  [260.5, 290.5, null, null],
  [261.0, 291.0, null, null],
  [261.5, 291.5, null, null],
  [262.0, 292.0, null, null],
  [262.5, 292.5, null, null],
  [263.0, 293.0, null, null],
  [263.5, 293.5, null, null],
  [264.0, 294.0, null, null],
  [264.5, 294.5, null, null],
  [265.0, 295.0, null, null],
  [265.5, 295.5, null, null],
  [266.0, 296.0, null, null],
  [266.5, 296.5, null, null],
  [267.0, 297.0, null, null],
  [267.5, 297.5, null, null],
  [268.0, 298.0, null, null],
  [268.5, 298.5, null, null],
  [269.0, 299.0, null, null],
  [269.5, 299.5, null, null],
  [270.0, 300.0, null, null],
  [270.5, 300.5, null, null],
  [271.0, 301.0, null, null],
  [271.5, 301.5, null, null],
  [272.0, 302.0, null, null],
  [272.5, 302.5, null, null],
  [273.0, 303.0, null, null],
  [273.5, 303.5, null, null],
  [274.0, 304.0, null, null],
  [274.5, 304.5, null, null],
  [275.0, 305.0, null, null],
  [275.5, 305.5, null, null],
  [276.0, 306.0, null, null],
  [276.5, 306.5, null, null],
  [277.0, 307.0, null, null],
  [277.5, 307.5, null, null],
  [278.0, 308.0, null, null],
  [278.5, 308.5, null, null],
  [279.0, 309.0, null, null],
  [279.5, 309.5, null, null],
  [280.0, 310.0, null, null],
  [280.5, 310.5, null, null],
  [281.0, 311.0, null, null],
  [281.5, 311.5, null, null],
  [282.0, 312.0, null, null],
  [282.5, 312.5, null, null],
  [283.0, 313.0, null, null],
  [283.5, 313.5, null, null],
  [284.0, 314.0, null, null],
  [284.5, 314.5, null, null],
  [285.0, 315.0, null, null],
  [285.5, 315.5, null, null],
  [286.0, 316.0, null, null],
  [286.5, 316.5, null, null],
  [287.0, 317.0, null, null],
  [287.5, 317.5, null, null],
  [288.0, 318.0, null, null],
  [288.5, 318.5, null, null],
  [289.0, 319.0, null, null],
  [289.5, 319.5, null, null],
  [290.0, 320.0, null, null],
  [290.5, 320.5, null, null],
  [291.0, 321.0, null, null],
  [291.5, 321.5, null, null],
  [292.0, 322.0, null, null],
  [292.5, 322.5, null, null],
  [293.0, 323.0, null, null],
  [293.5, 323.5, null, null],
  [294.0, 324.0, null, null],
  [294.5, 324.5, null, null],
  [295.0, 325.0, null, null],
  [295.5, 325.5, null, null],
  [296.0, 326.0, null, null],
  [296.5, 326.5, null, null],
  [297.0, 327.0, null, null],
  [297.5, 327.5, null, null],
  [298.0, 328.0, null, null],
  [298.5, 328.5, null, null],
  [299.0, 329.0, null, null],
  [299.5, 329.5, null, null],
  [300.0, 330.0, null, null],
  [300.5, 330.5, null, null],
  [301.0, 331.0, null, null],
  [301.5, 331.5, null, null],
  [302.0, 332.0, null, null],
  [302.5, 332.5, null, null],
  [303.0, 333.0, null, null],
  [303.5, 333.5, null, null],
  [304.0, 334.0, null, null],
  [304.5, 334.5, null, null],
  [305.0, 335.0, null, null],
  [305.5, 335.5, null, null],
  [306.0, 336.0, null, null],
  [306.5, 336.5, null, null],
  [307.0, 337.0, null, null],
  [307.5, 337.5, null, null],
  [308.0, 338.0, null, null],
  [308.5, 338.5, null, null],
  [309.0, 339.0, null, null],
  [309.5, 339.5, null, null],
  [310.0, 340.0, null, null],
  [310.5, 340.5, null, null],
  [311.0, 341.0, null, null],
  [311.5, 341.5, null, null],
  [312.0, 342.0, null, null],
  [312.5, 342.5, null, null],
  [313.0, 343.0, null, null],
  [313.5, 343.5, null, null],
  [314.0, 344.0, null, null],
  [314.5, 344.5, null, null],
  [315.0, 345.0, null, null],
  [315.5, 345.5, null, null],
  [316.0, 346.0, null, null],
  [316.5, 346.5, null, null],
  [317.0, 347.0, null, null],
  [317.5, 347.5, null, null],
  [318.0, 348.0, null, null],
  [318.5, 348.5, null, null],
  [319.0, 349.0, null, null],
  [319.5, 349.5, null, null],
  [320.0, 350.0, null, null],
  [320.5, 350.5, null, null],
  [321.0, 351.0, null, null],
  [321.5, 351.5, null, null],
  [322.0, 352.0, null, null],
  [322.5, 352.5, null, null],
  [323.0, 353.0, null, null],
  [323.5, 353.5, null, null],
  [324.0, 354.0, null, null],
  [324.5, 354.5, null, null],
  [325.0, 355.0, null, null],
  [325.5, 355.5, null, null],
  [326.0, 356.0, null, null],
  [326.5, 356.5, null, null],
  [327.0, 357.0, null, null],
  [327.5, 357.5, null, null],
  [328.0, 358.0, null, null],
  [328.5, 358.5, null, null],
  [329.0, 359.0, null, null],
  [329.5, 359.5, null, null],
  [330.0, 360.0, null, null],
  [330.5, 360.5, null, null],
  [331.0, 361.0, null, null],
  [331.5, 361.5, null, null],
  [332.0, 362.0, null, null],
  [332.5, 362.5, null, null],
  [333.0, 363.0, null, null],
  [333.5, 363.5, null, null],
  [334.0, 364.0, null, null],
  [334.5, 364.5, null, null],
  [335.0, 365.0, null, null],
  [335.5, 365.5, null, null],
  [336.0, 366.0, null, null],
  [336.5, 366.5, null, null],
  [337.0, 367.0, null, null],
  [337.5, 367.5, null, null],
  [338.0, 368.0, null, null],
  [338.5, 368.5, null, null],
  [339.0, 369.0, null, null],
  [339.5, 369.5, null, null],
  [340.0, 370.0, null, null],
  [340.5, 370.5, null, null],
  [341.0, 371.0, null, null],
  [341.5, 371.5, null, null],
  [342.0, 372.0, null, null],
  [342.5, 372.5, null, null],
  [343.0, 373.0, null, null],
  [343.5, 373.5, null, null],
  [344.0, 374.0, null, null],
  [344.5, 374.5, null, null],
  [345.0, 375.0, null, null],
  [345.5, 375.5, null, null],
  [346.0, 376.0, null, null],
  [346.5, 376.5, null, null],
  [347.0, 377.0, null, null],
  [347.5, 377.5, null, null],
  [348.0, 378.0, null, null],
  [348.5, 378.5, null, null],
  [349.0, 379.0, null, null],
  [349.5, 379.5, null, null],
  [350.0, 380.0, null, null],
  [350.5, 380.5, null, null],
  [351.0, 381.0, null, null],
  [351.5, 381.5, null, null],
  [352.0, 382.0, null, null],
  [352.5, 382.5, null, null],
  [353.0, 383.0, null, null],
  [353.5, 383.5, null, null],
  [354.0, 384.0, null, null],
  [354.5, 384.5, null, null],
  [355.0, 385.0, null, null],
  [355.5, 385.5, null, null],
  [356.0, 386.0, null, null],
  [356.5, 386.5, null, null],
  [357.0, 387.0, null, null],
  [357.5, 387.5, null, null],
  [358.0, 388.0, null, null],
  [358.5, 388.5, null, null],
  [359.0, 389.0, null, null],
  [359.5, 389.5, null, null],
  [360.0, 390.0, null, null],
  [360.5, 390.5, null, null],
  [361.0, 391.0, null, null],
  [361.5, 391.5, null, null],
  [362.0, 392.0, null, null],
  [362.5, 392.5, null, null],
  [363.0, 393.0, null, null],
  [363.5, 393.5, null, null],
  [364.0, 394.0, null, null],
  [364.5, 394.5, null, null],
  [365.0, 395.0, null, null],
  [365.5, 395.5, null, null],
  [366.0, 396.0, null, null],
  [366.5, 396.5, null, null],
  [367.0, 397.0, null, null],
  [367.5, 397.5, null, null],
  [368.0, 398.0, null, null],
  [368.5, 398.5, null, null],
  [369.0, 399.0, null, null],
  [369.5, 399.5, null, null],
  [370.0, 400.0, null, null],
  [370.5, 400.5, null, null],
  [371.0, 401.0, null, null],
  [371.5, 401.5, null, null],
  [372.0, 402.0, null, null],
  [372.5, 402.5, null, null],
  [373.0, 403.0, null, null],
  [373.5, 403.5, null, null],
  [374.0, 404.0, null, null],
  [374.5, 404.5, null, null],
  [375.0, 405.0, null, null],
  [375.5, 405.5, null, null],
  [376.0, 406.0, null, null],
  [376.5, 406.5, null, null],
  [377.0, 407.0, null, null],
  [377.5, 407.5, null, null],
  [378.0, 408.0, null, null],
  [378.5, 408.5, null, null],
  [379.0, 409.0, null, null],
  [379.5, 409.5, null, null],
  [380.0, 410.0, null, null],
  [380.5, 410.5, null, null],
  [381.0, 411.0, null, null],
  [381.5, 411.5, null, null],
  [382.0, 412.0, null, null],
  [382.5, 412.5, null, null],
  [383.0, 413.0, null, null],
  [383.5, 413.5, null, null],
  [384.0, 414.0, null, null],
  [384.5, 414.5, null, null],
  [385.0, 415.0, null, null],
  [385.5, 415.5, null, null],
  [386.0, 416.0, null, null],
  [386.5, 416.5, null, null],
  [387.0, 417.0, null, null],
  [387.5, 417.5, null, null],
  [388.0, 418.0, null, null],
  [388.5, 418.5, null, null],
  [389.0, 419.0, null, null],
  [389.5, 419.5, null, null],
  [390.0, 420.0, null, null],
  [390.5, 420.5, null, null],
  [391.0, 421.0, null, null],
  [391.5, 421.5, null, null],
  [392.0, 422.0, null, null],
  [392.5, 422.5, null, null],
  [393.0, 423.0, null, null],
  [393.5, 423.5, null, null],
  [394.0, 424.0, null, null],
  [394.5, 424.5, null, null],
  [395.0, 425.0, null, null],
  [395.5, 425.5, null, null],
  [396.0, 426.0, null, null],
  [396.5, 426.5, null, null],
  [397.0, 427.0, null, null],
  [397.5, 427.5, null, null],
  [398.0, 428.0, null, null],
  [398.5, 428.5, null, null],
  [399.0, 429.0, null, null],
  [399.5, 429.5, null, null],
  [400.0, 430.0, null, null],
  [400.5, 430.5, null, null],
  [401.0, 431.0, null, null],
  [401.5, 431.5, null, null],
  [402.0, 432.0, null, null],
  [402.5, 432.5, null, null],
  [403.0, 433.0, null, null],
  [403.5, 433.5, null, null],
  [404.0, 434.0, null, null],
  [404.5, 434.5, null, null],
  [405.0, 435.0, null, null],
  [405.5, 435.5, null, null],
  [406.0, 436.0, null, null],
  [406.5, 436.5, null, null],
  [407.0, 437.0, null, null],
  [407.5, 437.5, null, null],
  [408.0, 438.0, null, null],
  [408.5, 438.5, null, null],
  [409.0, 439.0, null, null],
  [409.5, 439.5, null, null],
  [410.0, 440.0, null, null],
  [410.5, 440.5, null, null],
  [411.0, 441.0, null, null],
  [411.5, 441.5, null, null],
  [412.0, 442.0, null, null],
  [412.5, 442.5, null, null],
  [413.0, 443.0, null, null],
  [413.5, 443.5, null, null],
  [414.0, 444.0, null, null],
  [414.5, 444.5, null, null],
  [415.0, 445.0, null, null],
  [415.5, 445.5, null, null],
  [416.0, 446.0, null, null],
  [416.5, 446.5, null, null],
  [417.0, 447.0, null, null],
  [417.5, 447.5, null, null],
  [418.0, 448.0, null, null],
  [418.5, 448.5, null, null],
  [419.0, 449.0, null, null],
  [419.5, 449.5, null, null],
  [420.0, 450.0, null, null],
  [420.5, 450.5, null, null],
  [421.0, 451.0, null, null],
  [421.5, 451.5, null, null],
  [422.0, 452.0, null, null],
  [422.5, 452.5, null, null],
  [423.0, 453.0, null, null],
  [423.5, 453.5, null, null],
  [424.0, 454.0, null, null],
  [424.5, 454.5, null, null],
  [425.0, 455.0, null, null],
  [425.5, 455.5, null, null],
  [426.0, 456.0, null, null],
  [426.5, 456.5, null, null],
  [427.0, 457.0, null, null],
  [427.5, 457.5, null, null],
  [428.0, 458.0, null, null],
  [428.5, 458.5, null, null],
  [429.0, 459.0, null, null],
  [429.5, 459.5, null, null],
  [430.0, 460.0, null, null],
  [430.5, 460.5, null, null],
  [431.0, 461.0, null, null],
  [431.5, 461.5, null, null],
  [432.0, 462.0, null, null],
  [432.5, 462.5, null, null],
  [433.0, 463.0, null, null],
  [433.5, 463.5, null, null],
  [434.0, 464.0, null, null],
  [434.5, 464.5, null, null],
  [435.0, 465.0, null, null],
  [435.5, 465.5, null, null],
  [436.0, 466.0, null, null],
  [436.5, 466.5, null, null],
  [437.0, 467.0, null, null],
  [437.5, 467.5, null, null],
  [438.0, 468.0, null, null],
  [438.5, 468.5, null, null],
  [439.0, 469.0, null, null],
  [439.5, 469.5, null, null],
  [440.0, 470.0, null, null],
  [440.5, 470.5, null, null],
  [441.0, 471.0, null, null],
  [441.5, 471.5, null, null],
  [442.0, 472.0, null, null],
  [442.5, 472.5, null, null],
  [443.0, 473.0, null, null],
  [443.5, 473.5, null, null],
  [444.0, 474.0, null, null],
  [444.5, 474.5, null, null],
  [445.0, 475.0, null, null],
  [445.5, 475.5, null, null],
  [446.0, 476.0, null, null],
  [446.5, 476.5, null, null],
  [447.0, 477.0, null, null],
  [447.5, 477.5, null, null],
  [448.0, 478.0, null, null],
  [448.5, 478.5, null, null],
  [449.0, 479.0, null, null],
  [449.5, 479.5, null, null],
  [450.0, 480.0, null, null],
  [450.5, 480.5, null, null],
  [451.0, 481.0, null, null],
  [451.5, 481.5, null, null],
  [452.0, 482.0, null, null],
  [452.5, 482.5, null, null],
  [453.0, 483.0, null, null],
  [453.5, 483.5, null, null],
  [454.0, 484.0, null, null],
  [454.5, 484.5, null, null],
  [455.0, 485.0, null, null],
  [455.5, 485.5, null, null],
  [456.0, 486.0, null, null],
  [456.5, 486.5, null, null],
  [457.0, 487.0, null, null],
  [457.5, 487.5, null, null],
  [458.0, 488.0, null, null],
  [458.5, 488.5, null, null],
  [459.0, 489.0, null, null],
  [459.5, 489.5, null, null]
];

export const BZ3: CurrentTempReading[] = [
  [194.3, 197.4, null, null],
  [195.7, 198.0, null, null],
  [196.6, 198.6, null, null],
  [197.7, 198.6, null, null],
  [198.4, 195.0, null, null],
  [196.1, 191.4, null, null],
  [189.1, 186.2, null, null],
  [181.4, 180.4, null, null],
  [173.9, 174.4, null, null],
  [166.5, 169.4, null, null],
  [160.1, 166.1, null, null],
  [155.5, 163.6, null, null],
  [150.9, 159.7, null, null],
  [145.3, 155.7, null, null],
  [139.4, 153.0, null, null],
  [134.0, 150.6, null, null],
  [129.0, 148.0, null, null],
  [124.5, 146.0, null, null],
  [120.5, 144.1, null, null],
  [117.1, 142.3, null, null],
  [113.4, 141.1, null, null],
  [110.3, 139.9, null, null],
  [107.3, 138.5, null, null],
  [104.7, 137.1, null, null],
  [102.4, 136.4, null, null],
  [99.7, 136.0, null, null],
  [97.5, 135.3, null, null],
  [95.5, 134.1, null, null],
  [93.3, 133.2, null, null],
  [91.7, 132.8, null, null],
  [90.2, 132.5, null, null],
  [88.6, 132.0, null, null],
  [87.3, 132.0, null, null],
  [86.0, 131.7, null, null],
  [84.8, 131.4, null, null],
  [84.1, 131.3, null, null],
  [83.4, 131.1, null, null],
  [82.5, 130.7, null, null],
  [81.6, 130.7, null, null],
  [81.3, 130.5, null, null],
  [80.6, 130.4, null, null],
  [80.0, 130.0, null, null],
  [79.8, 129.8, null, null],
  [79.1, 130.0, null, null],
  [79.0, 129.9, null, null],
  [78.9, 130.1, null, null],
  [78.7, 130.4, null, null],
  [78.6, 131.0, null, null],
  [78.5, 131.5, null, null],
  [78.7, 131.7, null, null],
  [78.5, 131.8, null, null],
  [78.8, 131.9, null, null],
  [78.4, 132.3, null, null],
  [78.6, 132.6, null, null],
  [78.7, 132.5, null, null],
  [78.7, 132.6, null, null],
  [79.0, 132.5, null, null],
  [79.4, 132.7, null, null],
  [79.5, 132.8, null, null],
  [79.7, 133.2, null, null],
  [80.0, 133.7, null, null],
  [80.3, 134.2, null, null],
  [80.6, 134.7, null, null],
  [81.1, 135.0, null, null],
  [81.3, 135.2, null, null],
  [81.7, 135.3, null, null],
  [82.2, 135.6, null, null],
  [82.6, 136.0, null, null],
  [83.1, 135.8, null, null],
  [83.4, 135.7, null, null],
  [83.9, 136.2, null, null],
  [84.3, 136.3, null, null],
  [84.7, 137.2, null, null],
  [84.9, 137.6, null, null],
  [85.5, 137.7, null, null],
  [85.8, 137.8, null, null],
  [86.3, 138.4, null, null],
  [86.7, 138.5, null, null],
  [87.2, 139.1, null, null],
  [87.6, 139.6, null, null],
  [87.9, 139.9, null, null],
  [88.4, 140.1, null, null],
  [89.0, 140.4, null, null],
  [89.5, 140.6, null, null],
  [89.9, 140.6, null, null],
  [90.2, 140.7, null, null],
  [90.7, 140.9, null, null],
  [91.2, 141.3, null, null],
  [91.6, 141.4, null, null],
  [92.3, 141.7, null, null],
  [92.5, 142.1, null, null],
  [93.0, 142.0, null, null],
  [93.6, 142.5, null, null],
  [93.9, 142.7, null, null],
  [94.4, 142.8, null, null],
  [94.7, 143.3, null, null],
  [95.3, 143.6, null, null],
  [95.7, 143.5, null, null],
  [96.0, 143.8, null, null],
  [96.4, 144.0, null, null],
  [97.0, 143.9, null, null],
  [97.4, 143.9, null, null],
  [97.6, 144.2, null, null],
  [98.2, 144.4, null, null],
  [98.6, 144.7, null, null],
  [99.0, 145.0, null, null],
  [99.3, 144.8, null, null],
  [99.7, 145.1, null, null],
  [100.4, 145.4, null, null],
  [100.5, 145.4, null, null],
  [100.9, 145.8, null, null],
  [101.5, 146.4, null, null],
  [101.9, 146.2, null, null],
  [102.4, 146.4, null, null],
  [102.6, 146.8, null, null],
  [103.1, 147.1, null, null],
  [103.6, 147.1, null, null],
  [104.0, 147.1, null, null],
  [104.3, 147.3, null, null],
  [104.7, 147.3, null, null],
  [105.0, 147.3, null, null],
  [105.5, 147.3, null, null],
  [106.0, 147.5, null, null],
  [106.3, 147.8, null, null],
  [106.8, 147.9, null, null],
  [106.9, 148.4, null, null],
  [107.3, 148.5, null, null],
  [107.7, 148.8, null, null],
  [108.0, 148.9, null, null],
  [108.4, 149.9, null, null],
  [108.9, 151.5, null, null],
  [109.2, 153.1, null, null],
  [109.6, 154.5, null, null],
  [109.9, 155.6, null, null],
  [110.3, 157.0, null, null],
  [110.9, 158.0, null, null],
  [111.0, 159.1, null, null],
  [111.5, 160.6, null, null],
  [111.8, 161.6, null, null],
  [112.0, 162.4, null, null],
  [112.5, 163.4, null, null],
  [112.8, 164.3, null, null],
  [113.4, 165.1, null, null],
  [113.6, 165.9, null, null],
  [114.2, 166.8, null, null],
  [114.5, 167.4, null, null],
  [114.8, 168.0, null, null],
  [115.3, 168.6, null, null],
  [115.6, 169.2, null, null],
  [115.8, 169.6, null, null],
  [116.4, 170.1, null, null],
  [116.9, 170.9, null, null],
  [117.0, 171.3, null, null],
  [117.5, 171.4, null, null],
  [117.7, 171.8, null, null],
  [118.0, 172.0, null, null],
  [118.4, 172.2, null, null],
  [118.9, 172.2, null, null],
  [119.1, 172.8, null, null],
  [119.5, 173.1, null, null],
  [119.8, 173.4, null, null],
  [120.1, 173.7, null, null],
  [120.6, 174.1, null, null],
  [121.1, 174.4, null, null],
  [121.4, 174.3, null, null],
  [121.6, 174.7, null, null],
  [122.1, 174.9, null, null],
  [122.2, 175.3, null, null],
  [122.6, 175.4, null, null],
  [123.2, 175.3, null, null],
  [123.4, 175.3, null, null],
  [123.9, 175.2, null, null],
  [124.1, 175.6, null, null],
  [124.4, 175.9, null, null],
  [124.8, 175.9, null, null],
  [125.1, 175.9, null, null],
  [125.4, 176.2, null, null],
  [125.8, 176.6, null, null],
  [126.0, 176.5, null, null],
  [126.3, 176.9, null, null],
  [126.9, 177.0, null, null],
  [127.2, 177.4, null, null],
  [127.6, 177.4, null, null],
  [127.8, 177.4, null, null],
  [128.1, 177.3, null, null],
  [128.5, 177.6, null, null],
  [128.8, 177.9, null, null],
  [129.3, 177.8, null, null],
  [129.8, 178.2, null, null],
  [130.2, 178.6, null, null],
  [130.2, 177.5, null, null],
  [130.5, 177.1, null, null],
  [130.5, 176.9, null, null],
  [130.6, 176.4, null, null],
  [131.2, 176.2, null, null],
  [131.2, 176.2, null, null],
  [131.7, 176.4, null, null],
  [131.9, 176.3, null, null],
  [132.5, 176.5, null, null],
  [132.6, 176.6, null, null],
  [133.0, 176.6, null, null],
  [133.1, 176.5, null, null],
  [133.5, 176.6, null, null],
  [133.7, 176.4, null, null],
  [134.2, 176.8, null, null],
  [134.4, 177.0, null, null],
  [134.6, 177.2, null, null],
  [135.0, 177.9, null, null],
  [135.2, 178.1, null, null],
  [135.6, 178.1, null, null],
  [135.9, 178.7, null, null],
  [136.3, 178.9, null, null],
  [136.4, 179.1, null, null],
  [136.8, 179.2, null, null],
  [137.1, 179.2, null, null],
  [137.3, 179.6, null, null],
  [137.7, 179.8, null, null],
  [137.9, 179.9, null, null],
  [138.3, 180.2, null, null],
  [138.5, 180.3, null, null],
  [138.7, 180.6, null, null],
  [139.0, 180.8, null, null],
  [139.5, 181.1, null, null],
  [139.4, 181.6, null, null],
  [139.8, 181.5, null, null],
  [140.3, 181.0, null, null],
  [140.4, 181.2, null, null],
  [140.7, 180.5, null, null],
  [141.1, 179.5, null, null],
  [141.2, 178.7, null, null],
  [141.3, 177.7, null, null],
  [141.5, 177.4, null, null],
  [142.0, 178.0, null, null],
  [142.3, 178.7, null, null],
  [142.5, 179.8, null, null],
  [142.8, 181.1, null, null],
  [143.0, 181.8, null, null],
  [143.2, 182.7, null, null],
  [143.6, 183.3, null, null],
  [143.8, 184.0, null, null],
  [144.1, 184.6, null, null],
  [144.4, 185.1, null, null],
  [144.8, 185.9, null, null],
  [144.9, 187.1, null, null],
  [145.2, 187.7, null, null],
  [145.4, 188.3, null, null],
  [145.6, 189.2, null, null],
  [145.8, 189.4, null, null],
  [146.1, 190.0, null, null],
  [146.5, 190.6, null, null],
  [146.8, 190.9, null, null],
  [147.1, 191.5, null, null],
  [147.3, 192.0, null, null],
  [147.6, 192.6, null, null],
  [147.9, 193.2, null, null],
  [148.1, 193.7, null, null],
  [148.5, 193.8, null, null],
  [148.6, 193.8, null, null],
  [149.1, 194.2, null, null],
  [149.4, 194.5, null, null],
  [149.5, 195.0, null, null],
  [149.9, 195.6, null, null],
  [150.2, 196.0, null, null],
  [150.3, 196.7, null, null],
  [150.6, 196.9, null, null],
  [150.9, 197.2, null, null],
  [151.2, 198.1, null, null],
  [151.5, 198.5, null, null],
  [151.8, 198.9, null, null],
  [152.1, 199.3, null, null],
  [152.2, 199.9, null, null],
  [152.6, 200.5, null, null],
  [152.7, 200.7, null, null],
  [153.0, 200.8, null, null],
  [153.3, 201.1, null, null],
  [153.5, 201.2, null, null],
  [153.9, 201.5, null, null],
  [154.3, 201.9, null, null],
  [154.7, 202.3, null, null],
  [154.9, 202.6, null, null],
  [155.0, 202.8, null, null],
  [155.4, 203.1, null, null],
  [155.9, 203.5, null, null],
  [156.1, 203.6, null, null],
  [156.2, 203.7, null, null],
  [156.8, 204.0, null, null],
  [157.0, 204.2, null, null],
  [157.4, 204.9, null, null],
  [157.5, 204.8, null, null],
  [157.8, 204.7, null, null],
  [158.2, 204.7, null, null],
  [158.4, 204.6, null, null],
  [158.6, 204.9, null, null],
  [158.7, 205.0, null, null],
  [159.1, 205.2, null, null],
  [159.3, 205.6, null, null],
  [159.6, 205.8, null, null],
  [159.8, 205.9, null, null],
  [160.1, 206.0, null, null],
  [160.4, 206.8, null, null],
  [160.6, 207.2, null, null],
  [160.9, 207.2, null, null],
  [161.2, 207.5, null, null],
  [161.3, 208.1, null, null],
  [161.7, 208.4, null, null],
  [161.9, 208.9, null, null],
  [162.1, 209.1, null, null],
  [162.4, 209.0, null, null],
  [162.7, 208.8, null, null],
  [162.8, 209.0, null, null],
  [163.1, 209.0, null, null],
  [163.5, 209.1, null, null],
  [163.5, 209.4, null, null],
  [163.7, 210.2, null, null],
  [164.0, 210.8, null, null],
  [164.3, 211.1, null, null],
  [164.7, 211.4, null, null],
  [164.9, 211.4, null, null],
  [165.4, 211.1, null, null],
  [165.5, 211.6, null, null],
  [165.8, 211.1, null, null],
  [166.1, 211.1, null, null],
  [166.5, 211.4, null, null],
  [166.8, 212.0, null, null],
  [167.1, 212.2, null, null],
  [167.4, 212.6, null, null],
  [167.6, 212.8, null, null],
  [167.8, 213.4, null, null],
  [168.2, 213.8, null, null],
  [168.3, 214.4, null, null],
  [168.7, 214.8, null, null],
  [168.9, 215.0, null, null],
  [169.0, 215.3, null, null],
  [169.3, 215.7, null, null],
  [169.7, 216.0, null, null],
  [170.0, 216.1, null, null],
  [170.5, 216.3, null, null],
  [170.6, 216.5, null, null],
  [170.9, 216.4, null, null],
  [171.2, 216.6, null, null],
  [171.4, 216.9, null, null],
  [171.8, 216.8, null, null],
  [171.9, 216.7, null, null],
  [171.9, 216.9, null, null],
  [172.4, 216.9, null, null],
  [172.6, 217.1, null, null],
  [172.7, 216.9, null, null],
  [173.0, 216.9, null, null],
  [173.3, 216.9, null, null],
  [173.6, 217.5, null, null],
  [173.9, 217.6, null, null],
  [174.3, 218.1, null, null],
  [174.5, 218.1, null, null],
  [174.8, 218.1, null, null],
  [174.9, 218.3, null, null],
  [175.4, 218.6, null, null],
  [175.5, 218.7, null, null],
  [176.0, 218.7, null, null],
  [176.1, 218.9, null, null],
  [176.4, 218.8, null, null],
  [176.7, 218.9, null, null],
  [176.8, 218.7, null, null],
  [177.1, 219.3, null, null],
  [177.4, 219.1, null, null],
  [177.6, 219.7, null, null],
  [177.9, 219.8, null, null],
  [178.0, 219.6, null, null],
  [178.2, 219.9, null, null],
  [178.5, 219.9, null, null],
  [178.8, 220.2, null, null],
  [179.1, 220.5, null, null],
  [179.3, 220.6, null, null],
  [179.5, 221.1, null, null],
  [179.7, 221.3, null, null],
  [179.9, 221.8, null, null],
  [180.2, 221.6, null, null],
  [180.3, 221.8, null, null],
  [180.6, 222.3, null, null],
  [180.9, 222.6, null, null],
  [181.1, 222.9, null, null],
  [181.4, 223.1, null, null],
  [181.6, 223.2, null, null],
  [181.6, 224.1, null, null],
  [182.1, 224.7, null, null],
  [182.3, 224.7, null, null],
  [182.7, 224.9, null, null],
  [182.9, 224.8, null, null],
  [183.1, 224.8, null, null],
  [183.2, 224.8, null, null],
  [183.7, 225.1, null, null],
  [183.8, 225.3, null, null],
  [184.0, 225.4, null, null],
  [184.4, 225.9, null, null],
  [184.7, 225.9, null, null],
  [185.0, 226.4, null, null],
  [185.2, 226.7, null, null],
  [185.6, 227.0, null, null],
  [185.8, 226.9, null, null],
  [185.9, 226.8, null, null],
  [186.2, 226.8, null, null],
  [186.5, 227.0, null, null],
  [186.7, 227.4, null, null],
  [187.1, 227.7, null, null],
  [187.2, 228.1, null, null],
  [187.5, 228.5, null, null],
  [187.7, 228.8, null, null],
  [188.0, 228.8, null, null],
  [188.3, 228.8, null, null],
  [188.5, 229.0, null, null],
  [188.9, 229.2, null, null],
  [188.8, 228.3, null, null],
  [189.4, 227.2, null, null],
  [189.5, 226.5, null, null],
  [189.5, 225.5, null, null],
  [189.6, 224.7, null, null],
  [190.1, 224.4, null, null],
  [190.3, 223.8, null, null],
  [190.4, 223.1, null, null],
  [190.9, 222.6, null, null],
  [191.0, 221.9, null, null],
  [191.1, 221.3, null, null],
  [191.4, 221.0, null, null],
  [191.6, 220.6, null, null],
  [192.0, 220.3, null, null],
  [191.9, 219.9, null, null],
  [192.1, 219.5, null, null],
  [192.2, 219.6, null, null],
  [192.3, 219.2, null, null],
  [192.6, 219.2, null, null],
  [192.9, 219.2, null, null],
  [193.2, 219.1, null, null],
  [193.1, 218.6, null, null],
  [193.3, 218.3, null, null],
  [193.2, 218.2, null, null],
  [193.5, 218.1, null, null],
  [193.7, 218.0, null, null],
  [193.7, 218.1, null, null],
  [193.7, 218.0, null, null],
  [194.1, 217.8, null, null],
  [194.3, 217.8, null, null],
  [194.4, 217.5, null, null],
  [194.4, 217.4, null, null],
  [194.7, 217.4, null, null],
  [194.9, 217.3, null, null],
  [194.9, 217.3, null, null],
  [195.3, 217.1, null, null],
  [195.2, 217.0, null, null],
  [195.4, 217.1, null, null],
  [195.5, 217.0, null, null],
  [195.6, 217.1, null, null],
  [195.9, 217.0, null, null],
  [196.0, 216.9, null, null],
  [196.1, 216.9, null, null],
  [196.1, 216.7, null, null],
  [196.5, 216.7, null, null],
  [196.4, 216.6, null, null],
  [196.6, 216.7, null, null],
  [196.8, 216.7, null, null],
  [197.1, 216.4, null, null],
  [196.9, 216.6, null, null],
  [197.2, 216.3, null, null],
  [197.3, 216.4, null, null],
  [197.5, 216.5, null, null],
  [197.7, 216.4, null, null],
  [197.8, 216.3, null, null],
  [198.1, 216.3, null, null],
  [198.2, 216.4, null, null],
  [198.6, 216.3, null, null],
  [198.5, 216.2, null, null],
  [198.7, 216.2, null, null],
  [198.8, 216.2, null, null],
  [198.9, 216.2, null, null],
  [199.1, 216.2, null, null],
  [199.3, 216.4, null, null],
  [199.3, 216.2, null, null],
  [199.5, 216.3, null, null],
  [199.6, 216.1, null, null],
  [199.4, 215.9, null, null],
  [199.8, 215.8, null, null],
  [199.8, 215.8, null, null],
  [199.9, 215.5, null, null],
  [200.0, 215.6, null, null],
  [200.4, 215.7, null, null],
  [200.5, 215.6, null, null],
  [200.4, 215.5, null, null],
  [200.6, 215.6, null, null],
  [200.7, 215.5, null, null],
  [200.7, 215.4, null, null],
  [201.0, 215.5, null, null],
  [201.2, 215.7, null, null],
  [201.0, 215.5, null, null],
  [201.4, 215.5, null, null],
  [201.4, 215.5, null, null],
  [201.5, 215.5, null, null],
  [201.5, 215.5, null, null],
  [201.6, 215.3, null, null],
  [201.9, 215.3, null, null],
  [201.9, 215.2, null, null],
  [202.2, 215.3, null, null],
  [202.2, 215.3, null, null],
  [202.2, 215.7, null, null],
  [202.2, 215.5, null, null],
  [202.5, 215.6, null, null],
  [202.6, 215.5, null, null],
  [202.5, 215.3, null, null],
  [202.7, 215.4, null, null],
  [203.0, 215.5, null, null],
  [203.2, 215.4, null, null],
  [203.1, 215.5, null, null],
  [203.0, 215.3, null, null],
  [203.0, 215.4, null, null],
  [203.3, 215.5, null, null],
  [203.1, 215.4, null, null],
  [203.3, 215.4, null, null],
  [203.4, 215.5, null, null],
  [203.3, 215.5, null, null],
  [203.5, 215.2, null, null],
  [203.3, 215.1, null, null],
  [203.6, 215.0, null, null],
  [203.3, 214.8, null, null],
  [203.8, 214.8, null, null],
  [203.7, 214.8, null, null],
  [203.8, 214.8, null, null],
  [203.9, 214.8, null, null],
  [204.1, 214.9, null, null],
  [204.1, 214.7, null, null],
  [204.2, 214.7, null, null],
  [204.2, 214.6, null, null],
  [204.1, 214.4, null, null],
  [204.4, 214.4, null, null],
  [204.2, 214.4, null, null],
  [204.1, 214.1, null, null],
  [204.2, 214.1, null, null],
  [204.4, 214.2, null, null],
  [204.5, 214.2, null, null],
  [204.4, 214.2, null, null],
  [204.4, 214.2, null, null],
  [204.3, 214.1, null, null],
  [204.1, 214.1, null, null],
  [204.0, 214.0, null, null],
  [204.2, 213.9, null, null],
  [204.4, 213.9, null, null],
  [204.3, 213.8, null, null],
  [204.3, 213.7, null, null],
  [204.1, 213.6, null, null],
  [204.3, 214.1, null, null],
  [204.4, 214.6, null, null],
  [204.5, 214.9, null, null],
  [204.4, 214.9, null, null],
  [204.4, 215.3, null, null],
  [204.4, 215.6, null, null],
  [204.4, 215.8, null, null],
  [204.4, 215.9, null, null],
  [204.6, 216.1, null, null],
  [204.4, 216.1, null, null],
  [204.4, 216.2, null, null],
  [204.3, 216.3, null, null],
  [204.4, 216.5, null, null],
  [204.5, 216.7, null, null],
  [204.5, 217.1, null, null],
  [204.4, 217.2, null, null],
  [204.7, 217.1, null, null],
  [204.8, 216.8, null, null],
  [204.7, 216.6, null, null],
  [204.9, 216.5, null, null],
  [205.0, 216.5, null, null],
  [205.2, 216.3, null, null],
  [205.1, 216.1, null, null],
  [205.3, 216.1, null, null],
  [205.1, 215.9, null, null],
  [205.1, 215.6, null, null],
  [205.2, 215.3, null, null],
  [205.3, 215.1, null, null],
  [205.3, 215.3, null, null],
  [205.3, 215.0, null, null],
  [205.4, 214.8, null, null],
  [205.3, 214.5, null, null],
  [205.6, 214.7, null, null],
  [205.6, 214.7, null, null],
  [205.3, 214.7, null, null],
  [205.3, 214.6, null, null],
  [205.1, 214.4, null, null],
  [205.6, 214.4, null, null],
  [205.6, 214.5, null, null],
  [205.6, 214.6, null, null],
  [205.7, 214.6, null, null],
  [205.8, 214.7, null, null],
  [205.6, 214.5, null, null],
  [205.9, 214.6, null, null],
  [205.7, 214.6, null, null],
  [206.0, 214.7, null, null],
  [205.8, 214.6, null, null],
  [206.1, 214.5, null, null],
  [205.9, 214.5, null, null],
  [206.1, 214.6, null, null],
  [206.1, 214.7, null, null],
  [206.2, 214.5, null, null],
  [206.3, 214.5, null, null],
  [206.3, 214.4, null, null],
  [206.2, 214.4, null, null],
  [206.5, 214.5, null, null],
  [206.5, 214.4, null, null],
  [206.7, 214.7, null, null],
  [206.8, 214.6, null, null],
  [206.8, 214.5, null, null],
  [206.8, 214.6, null, null],
  [206.9, 214.6, null, null],
  [206.8, 214.5, null, null],
  [206.8, 214.4, null, null],
  [206.8, 214.7, null, null],
  [207.1, 214.8, null, null],
  [207.3, 215.0, null, null],
  [207.1, 214.9, null, null],
  [207.2, 215.0, null, null],
  [207.4, 215.1, null, null],
  [207.4, 215.2, null, null],
  [207.7, 215.3, null, null],
  [207.7, 215.2, null, null],
  [207.7, 215.1, null, null],
  [207.9, 215.4, null, null],
  [207.7, 215.3, null, null],
  [207.9, 215.3, null, null],
  [207.9, 215.3, null, null],
  [207.9, 215.3, null, null],
  [207.9, 215.2, null, null],
  [208.0, 215.2, null, null],
  [208.1, 215.3, null, null],
  [208.3, 215.5, null, null],
  [208.4, 215.6, null, null],
  [208.6, 215.4, null, null],
  [208.5, 215.9, null, null],
  [208.4, 215.8, null, null],
  [208.4, 215.8, null, null],
  [208.5, 215.8, null, null],
  [208.5, 215.9, null, null],
  [208.6, 216.1, null, null],
  [208.8, 216.3, null, null],
  [208.9, 216.3, null, null],
  [208.6, 216.4, null, null],
  [209.0, 216.6, null, null],
  [209.1, 216.6, null, null],
  [209.2, 216.6, null, null],
  [209.2, 216.9, null, null],
  [209.3, 217.0, null, null],
  [209.5, 216.9, null, null],
  [209.5, 216.8, null, null],
  [209.3, 217.0, null, null],
  [209.5, 217.2, null, null],
  [209.7, 217.0, null, null],
  [209.7, 217.2, null, null],
  [209.8, 217.3, null, null],
  [209.9, 217.6, null, null],
  [210.1, 217.6, null, null],
  [210.3, 217.6, null, null],
  [210.2, 217.6, null, null],
  [210.3, 217.8, null, null],
  [210.4, 217.8, null, null],
  [210.4, 217.8, null, null],
  [210.7, 218.2, null, null],
  [210.8, 218.4, null, null],
  [210.7, 218.2, null, null],
  [210.8, 218.2, null, null],
  [211.1, 218.4, null, null],
  [211.1, 218.7, null, null],
  [211.5, 218.8, null, null],
  [211.4, 218.8, null, null],
  [211.7, 218.7, null, null],
  [211.6, 218.8, null, null],
  [211.7, 218.9, null, null],
  [212.0, 218.8, null, null],
  [211.9, 219.1, null, null],
  [212.1, 219.1, null, null],
  [212.2, 219.0, null, null],
  [212.3, 219.0, null, null],
  [212.5, 219.0, null, null],
  [212.6, 216.0, null, null],
  [211.8, 213.0, null, null],
  [206.9, 209.8, null, null],
  [201.5, 207.9, null, null],
  [195.0, 205.6, null, null],
  [190.9, 202.8, null, null],
  [186.6, 199.5, null, null],
  [181.6, 198.2, null, null],
  [179.8, 199.2, null, null],
  [180.8, 200.9, null, null],
  [182.4, 202.5, null, null],
  [184.1, 203.8, null, null]
];

export const Kenya: CurrentTempReading[] = [
  [192.6, 178.1, null, 122.8],
  [192.9, 178.1, null, 123.1],
  [192.9, 178.4, null, 123.3],
  [192.6, 177.8, null, 123.7],
  [192.3, 176.9, null, 123.7],
  [191.2, 176.0, null, 123.7],
  [190.2, 174.7, null, 124.2],
  [188.7, 173.2, null, 124.4],
  [187.1, 171.8, null, 124.0],
  [185.4, 169.7, null, 124.2],
  [183.9, 168.6, null, 123.5],
  [181.5, 167.3, null, 123.3],
  [179.7, 165.9, null, 123.0],
  [177.8, 164.4, null, 122.8],
  [175.9, 163.2, null, 123.0],
  [174.0, 162.2, null, 123.3],
  [171.9, 160.9, null, 128.4],
  [170.0, 159.9, null, 138.5],
  [168.0, 158.6, null, 151.7],
  [166.0, 157.9, null, 166.5],
  [164.0, 156.9, null, 182.4],
  [162.2, 156.2, null, 199.4],
  [160.6, 155.0, null, 216.0],
  [158.7, 154.5, null, 231.9],
  [156.9, 153.9, null, 248.0],
  [155.1, 152.8, null, 262.5],
  [153.4, 152.1, null, 276.9],
  [151.7, 151.4, null, 290.5],
  [150.1, 151.2, null, 303.7],
  [148.7, 150.4, null, 316.1],
  [147.0, 149.9, null, 327.7],
  [145.2, 149.5, null, 338.9],
  [144.0, 148.5, null, 349.6],
  [142.2, 148.1, null, 359.9],
  [140.7, 147.9, null, 369.2],
  [139.5, 147.2, null, 378.2],
  [138.2, 146.8, null, 386.6],
  [136.5, 146.4, null, 395.4],
  [135.4, 146.2, null, 403.1],
  [134.3, 145.8, null, 411.0],
  [132.8, 145.5, null, 418.7],
  [131.3, 145.3, null, 425.9],
  [130.2, 144.9, null, 432.9],
  [129.1, 144.5, null, 438.7],
  [128.0, 144.4, null, 444.1],
  [126.9, 144.1, null, 449.3],
  [125.7, 144.1, null, 454.2],
  [124.3, 143.8, null, 458.9],
  [123.4, 143.5, null, 463.4],
  [122.5, 143.4, null, 467.7],
  [121.3, 143.2, null, 471.5],
  [120.1, 143.0, null, 475.5],
  [119.6, 143.1, null, 479.1],
  [118.7, 142.9, null, 482.4],
  [117.7, 142.9, null, 486.0],
  [116.8, 142.5, null, 489.4],
  [115.8, 142.3, null, 493.2],
  [114.9, 142.2, null, 496.3],
  [114.0, 142.0, null, 499.4],
  [113.1, 142.1, null, 502.8],
  [112.6, 141.9, null, 505.4],
  [111.8, 141.7, null, 508.6],
  [110.7, 141.8, null, 510.8],
  [110.1, 142.0, null, 513.3],
  [109.7, 142.0, null, 515.3],
  [108.8, 141.6, null, 517.1],
  [108.1, 141.7, null, 519.1],
  [107.5, 141.6, null, 521.2],
  [106.8, 141.4, null, 522.9],
  [106.3, 141.6, null, 524.5],
  [105.3, 141.6, null, 525.8],
  [105.1, 141.3, null, 528.1],
  [104.3, 141.6, null, 529.7],
  [103.8, 141.6, null, 531.5],
  [103.5, 141.6, null, 532.8],
  [102.9, 141.5, null, 533.9],
  [102.4, 141.8, null, 535.0],
  [101.8, 141.5, null, 536.4],
  [101.7, 141.5, null, 537.5],
  [100.9, 141.6, null, 539.3],
  [100.5, 141.5, null, 540.2],
  [100.3, 141.5, null, 541.5],
  [99.9, 141.6, null, 543.3],
  [99.3, 141.7, null, 544.9],
  [98.9, 141.7, null, 545.3],
  [98.4, 141.8, null, 546.5],
  [98.2, 141.9, null, 546.9],
  [97.7, 141.7, null, 546.9],
  [97.3, 142.0, null, 547.1],
  [97.0, 142.0, null, 547.8],
  [96.9, 141.7, null, 548.5],
  [96.6, 142.0, null, 549.4],
  [96.1, 142.1, null, 550.5],
  [95.8, 142.1, null, 551.2],
  [95.6, 142.0, null, 552.5],
  [95.3, 141.9, null, 553.4],
  [95.2, 142.1, null, 554.3],
  [94.7, 142.1, null, 555.2],
  [94.5, 142.3, null, 555.8],
  [94.1, 142.2, null, 556.5],
  [94.0, 142.4, null, 557.0],
  [93.9, 142.3, null, 557.4],
  [93.5, 142.4, null, 557.8],
  [93.4, 142.4, null, 558.3],
  [93.2, 142.5, null, 558.1],
  [92.7, 142.5, null, 558.5],
  [93.0, 142.6, null, 558.7],
  [92.6, 142.4, null, 559.2],
  [92.5, 142.6, null, 559.4],
  [92.6, 142.8, null, 559.9],
  [92.3, 142.8, null, 560.5],
  [92.4, 142.8, null, 561.2],
  [91.8, 142.9, null, 561.7],
  [91.9, 142.8, null, 562.5],
  [91.9, 142.6, null, 563.7],
  [91.7, 142.9, null, 564.8],
  [91.7, 142.9, null, 565.9],
  [91.3, 142.8, null, 566.5],
  [91.1, 143.3, null, 567.0],
  [91.3, 143.2, null, 567.5],
  [91.1, 143.1, null, 567.7],
  [91.1, 143.1, null, 568.4],
  [91.0, 143.5, null, 568.8],
  [91.1, 143.3, null, 569.3],
  [91.0, 143.2, null, 570.2],
  [90.9, 143.3, null, 570.4],
  [91.0, 143.5, null, 570.6],
  [90.9, 143.5, null, 571.3],
  [90.9, 143.4, null, 571.5],
  [91.1, 143.5, null, 571.7],
  [91.0, 143.7, null, 571.7],
  [90.8, 143.8, null, 572.4],
  [90.8, 143.8, null, 572.4],
  [90.7, 144.0, null, 572.7],
  [90.8, 144.2, null, 573.3],
  [90.7, 144.0, null, 573.4],
  [90.7, 144.1, null, 573.8],
  [90.8, 144.1, null, 573.8],
  [91.0, 144.2, null, 573.8],
  [91.0, 144.2, null, 573.8],
  [91.1, 144.6, null, 574.7],
  [91.0, 144.1, null, 575.6],
  [91.1, 144.5, null, 576.5],
  [91.3, 144.4, null, 577.2],
  [91.3, 144.8, null, 578.1],
  [91.0, 144.6, null, 578.7],
  [91.0, 144.7, null, 579.0],
  [91.3, 144.9, null, 579.9],
  [91.3, 144.8, null, 580.1],
  [91.3, 144.9, null, 580.5],
  [91.4, 144.9, null, 581.0],
  [91.2, 144.7, null, 581.4],
  [91.2, 144.9, null, 582.1],
  [91.3, 145.1, null, 583.0],
  [91.5, 145.1, null, 583.4],
  [91.8, 145.5, null, 583.4],
  [91.7, 145.1, null, 583.4],
  [91.6, 145.2, null, 583.6],
  [91.6, 145.3, null, 583.6],
  [91.7, 145.4, null, 583.9],
  [92.0, 145.4, null, 584.1],
  [91.9, 145.2, null, 583.9],
  [92.0, 145.9, null, 583.4],
  [92.2, 146.5, null, 583.4],
  [92.5, 146.9, null, 583.9],
  [92.4, 147.6, null, 584.1],
  [92.4, 148.3, null, 585.0],
  [92.6, 149.2, null, 585.2],
  [92.8, 150.4, null, 585.9],
  [92.8, 151.0, null, 586.3],
  [93.2, 152.1, null, 587.0],
  [93.0, 153.2, null, 587.4],
  [93.1, 154.2, null, 587.7],
  [93.7, 155.1, null, 587.7],
  [93.6, 156.3, null, 587.6],
  [93.8, 157.2, null, 588.1],
  [94.0, 158.0, null, 588.3],
  [94.1, 159.0, null, 588.7],
  [94.5, 159.9, null, 589.2],
  [94.6, 160.9, null, 589.6],
  [94.7, 161.6, null, 590.3],
  [94.8, 162.8, null, 590.5],
  [95.1, 163.6, null, 591.0],
  [95.4, 164.5, null, 591.0],
  [95.5, 165.5, null, 591.7],
  [95.4, 166.1, null, 592.8],
  [96.1, 166.9, null, 593.3],
  [96.1, 167.6, null, 594.2],
  [96.1, 168.4, null, 594.8],
  [96.6, 169.2, null, 595.3],
  [96.7, 169.8, null, 596.2],
  [96.6, 170.4, null, 596.2],
  [97.1, 171.1, null, 596.4],
  [97.2, 171.8, null, 596.8],
  [97.3, 172.3, null, 597.3],
  [98.0, 173.1, null, 598.0],
  [98.0, 173.7, null, 598.2],
  [98.1, 174.2, null, 598.9],
  [98.3, 174.8, null, 599.3],
  [98.7, 175.1, null, 600.0],
  [98.8, 175.8, null, 600.9],
  [99.0, 176.1, null, 601.5],
  [99.0, 176.6, null, 601.8],
  [99.2, 177.1, null, 602.2],
  [99.6, 177.6, null, 602.7],
  [99.8, 178.1, null, 602.7],
  [99.9, 178.7, null, 602.7],
  [100.1, 178.9, null, 602.2],
  [100.3, 179.3, null, 601.8],
  [100.9, 179.9, null, 601.3],
  [101.1, 180.0, null, 601.6],
  [101.1, 180.6, null, 601.3],
  [101.4, 180.7, null, 601.6],
  [101.9, 181.3, null, 601.6],
  [101.9, 181.5, null, 601.6],
  [102.0, 182.0, null, 601.6],
  [102.4, 182.4, null, 601.6],
  [102.8, 182.6, null, 601.8],
  [102.8, 183.0, null, 601.8],
  [103.0, 183.5, null, 601.8],
  [103.3, 183.6, null, 602.0],
  [103.5, 183.8, null, 602.3],
  [103.9, 184.4, null, 602.3],
  [104.4, 184.4, null, 602.5],
  [104.5, 184.9, null, 602.5],
  [104.8, 185.0, null, 602.7],
  [105.2, 185.5, null, 603.0],
  [105.4, 185.7, null, 602.8],
  [105.4, 186.0, null, 602.8],
  [105.4, 186.0, null, 602.3],
  [105.8, 186.6, null, 601.6],
  [106.1, 186.9, null, 601.0],
  [106.2, 187.2, null, 600.5],
  [106.4, 187.3, null, 601.0],
  [106.9, 187.6, null, 601.2],
  [107.1, 187.5, null, 600.9],
  [107.1, 187.8, null, 601.2],
  [107.5, 188.0, null, 601.2],
  [107.7, 188.5, null, 600.9],
  [108.1, 188.7, null, 601.4],
  [108.4, 188.9, null, 601.2],
  [108.3, 189.1, null, 600.9],
  [108.6, 189.3, null, 600.9],
  [109.2, 189.6, null, 601.2],
  [109.1, 189.6, null, 601.4],
  [109.6, 189.9, null, 601.8],
  [109.9, 190.2, null, 601.6],
  [110.1, 190.2, null, 601.4],
  [110.3, 190.5, null, 601.4],
  [110.3, 190.7, null, 601.9],
  [111.1, 190.8, null, 602.3],
  [111.1, 191.3, null, 602.5],
  [111.3, 191.1, null, 602.3],
  [111.3, 191.4, null, 602.3],
  [111.8, 191.5, null, 601.6],
  [112.1, 191.6, null, 601.2],
  [112.2, 192.0, null, 601.2],
  [112.5, 192.2, null, 600.5],
  [112.8, 192.4, null, 600.5],
  [112.9, 192.6, null, 600.5],
  [113.1, 192.7, null, 600.3],
  [113.6, 192.9, null, 600.5],
  [113.6, 192.9, null, 601.0],
  [114.0, 193.2, null, 601.2],
  [114.4, 193.4, null, 601.9],
  [114.7, 193.6, null, 602.1],
  [115.1, 193.8, null, 602.6],
  [115.0, 194.1, null, 603.0],
  [115.3, 194.2, null, 603.7],
  [115.6, 194.8, null, 603.7],
  [116.0, 194.6, null, 604.2],
  [115.9, 194.6, null, 604.4],
  [116.4, 194.9, null, 604.6],
  [116.6, 195.2, null, 604.6],
  [116.7, 195.3, null, 604.6],
  [117.0, 195.6, null, 604.0],
  [117.4, 195.8, null, 604.2],
  [117.6, 195.9, null, 604.4],
  [118.0, 196.1, null, 604.2],
  [118.4, 196.3, null, 604.4],
  [118.6, 196.4, null, 604.7],
  [118.6, 196.6, null, 604.4],
  [119.2, 196.8, null, 604.4],
  [119.5, 197.0, null, 604.7],
  [119.6, 197.1, null, 604.4],
  [119.9, 197.2, null, 604.2],
  [120.2, 197.4, null, 604.4],
  [120.3, 197.5, null, 604.2],
  [120.3, 197.6, null, 603.6],
  [121.0, 197.8, null, 603.1],
  [121.0, 198.1, null, 602.7],
  [121.4, 198.2, null, 602.7],
  [121.7, 198.3, null, 602.2],
  [121.9, 198.7, null, 601.6],
  [121.9, 198.6, null, 600.9],
  [122.3, 198.8, null, 600.4],
  [122.9, 199.2, null, 600.0],
  [122.7, 199.3, null, 599.5],
  [123.1, 199.5, null, 600.0],
  [123.6, 199.5, null, 599.3],
  [123.7, 199.9, null, 599.5],
  [124.0, 199.9, null, 599.3],
  [124.1, 199.9, null, 599.1],
  [124.6, 200.1, null, 599.1],
  [124.9, 200.4, null, 599.3],
  [125.1, 200.4, null, 600.0],
  [125.2, 200.6, null, 600.4],
  [125.3, 200.7, null, 600.9],
  [125.9, 200.8, null, 601.5],
  [126.3, 200.9, null, 602.2],
  [126.4, 201.3, null, 602.9],
  [126.4, 201.4, null, 603.7],
  [126.8, 201.4, null, 604.2],
  [127.1, 201.5, null, 605.1],
  [127.5, 201.6, null, 605.8],
  [127.6, 202.2, null, 606.4],
  [127.9, 201.7, null, 607.1],
  [128.2, 202.0, null, 607.5],
  [128.2, 202.2, null, 608.0],
  [128.6, 202.3, null, 608.2],
  [128.5, 202.3, null, 608.4],
  [128.8, 202.4, null, 608.9],
  [129.2, 202.6, null, 609.1],
  [129.6, 202.6, null, 609.3],
  [129.8, 203.1, null, 609.6],
  [130.1, 203.1, null, 610.0],
  [130.3, 203.2, null, 610.2],
  [130.4, 203.5, null, 610.5],
  [131.0, 203.5, null, 610.7],
  [131.3, 203.8, null, 610.0],
  [131.5, 203.6, null, 610.0],
  [131.8, 203.8, null, 609.8],
  [131.9, 204.0, null, 609.1],
  [132.2, 204.1, null, 608.7],
  [132.5, 204.3, null, 608.7],
  [132.8, 204.6, null, 608.2],
  [133.0, 204.6, null, 607.6],
  [133.1, 204.6, null, 606.9],
  [133.2, 205.1, null, 606.0],
  [133.6, 205.1, null, 605.3],
  [134.0, 205.1, null, 605.1],
  [134.3, 205.3, null, 605.3],
  [134.4, 205.6, null, 606.2],
  [134.9, 205.7, null, 606.9],
  [135.3, 205.7, null, 607.1],
  [135.3, 206.1, null, 607.1],
  [135.4, 206.2, null, 607.6],
  [135.8, 206.2, null, 607.6],
  [135.8, 206.4, null, 607.8],
  [136.2, 206.4, null, 608.0],
  [136.4, 206.5, null, 608.0],
  [137.0, 206.6, null, 608.5],
  [137.0, 207.0, null, 608.9],
  [137.0, 207.2, null, 608.7],
  [137.6, 207.2, null, 609.6],
  [137.8, 207.6, null, 610.5],
  [137.7, 207.6, null, 610.7],
  [138.3, 208.1, null, 611.2],
  [138.4, 207.8, null, 611.4],
  [138.7, 207.9, null, 612.0],
  [138.9, 208.3, null, 612.0],
  [139.0, 208.5, null, 612.5],
  [139.3, 208.3, null, 612.7],
  [139.5, 208.7, null, 612.3],
  [139.9, 208.8, null, 612.7],
  [140.1, 208.8, null, 612.5],
  [140.4, 209.2, null, 612.7],
  [140.6, 209.2, null, 612.5],
  [140.8, 209.3, null, 612.1],
  [141.3, 209.0, null, 611.6],
  [141.5, 209.5, null, 611.0],
  [141.9, 209.5, null, 610.7],
  [142.2, 209.4, null, 610.5],
  [142.3, 209.8, null, 610.5],
  [142.7, 210.0, null, 610.3],
  [142.7, 210.0, null, 610.3],
  [143.0, 210.4, null, 610.3],
  [143.3, 210.4, null, 609.6],
  [143.5, 210.3, null, 609.0],
  [143.8, 210.5, null, 608.8],
  [143.9, 210.9, null, 608.1],
  [144.4, 211.0, null, 607.4],
  [144.7, 211.1, null, 607.6],
  [145.1, 210.9, null, 607.2],
  [145.1, 211.4, null, 607.6],
  [145.2, 211.2, null, 608.1],
  [145.5, 211.2, null, 608.5],
  [145.9, 211.4, null, 608.8],
  [146.2, 211.7, null, 609.2],
  [146.4, 211.7, null, 609.5],
  [146.8, 211.7, null, 609.9],
  [147.0, 212.2, null, 610.6],
  [147.5, 212.1, null, 611.0],
  [147.6, 212.3, null, 611.7],
  [147.9, 212.6, null, 612.1],
  [147.9, 212.6, null, 612.6],
  [148.3, 212.7, null, 613.3],
  [148.5, 212.8, null, 613.5],
  [149.0, 213.0, null, 613.5],
  [148.9, 213.2, null, 613.9],
  [149.4, 213.3, null, 614.4],
  [149.6, 213.4, null, 614.8],
  [149.7, 213.4, null, 615.3],
  [150.2, 213.6, null, 615.3],
  [150.3, 213.8, null, 615.7],
  [150.6, 213.9, null, 616.2],
  [151.1, 214.0, null, 616.4],
  [150.9, 214.1, null, 616.4],
  [151.3, 214.2, null, 616.4],
  [151.6, 214.3, null, 616.6],
  [152.0, 214.4, null, 616.4],
  [152.3, 214.6, null, 616.4],
  [152.4, 215.0, null, 616.2],
  [152.6, 214.9, null, 616.2],
  [152.6, 215.0, null, 616.2],
  [153.0, 215.2, null, 616.2],
  [153.2, 215.2, null, 615.7],
  [153.5, 215.4, null, 615.3],
  [153.6, 215.5, null, 615.7],
  [154.1, 215.8, null, 615.7],
  [154.3, 215.6, null, 615.9],
  [154.3, 215.9, null, 615.3],
  [154.9, 215.9, null, 615.5],
  [155.0, 216.2, null, 615.7],
  [155.4, 216.2, null, 615.5],
  [155.4, 216.4, null, 616.0],
  [155.8, 216.3, null, 617.1],
  [156.1, 216.5, null, 617.5],
  [156.2, 216.8, null, 617.5],
  [156.4, 216.8, null, 618.0],
  [157.0, 217.0, null, 618.2],
  [157.0, 216.8, null, 618.6],
  [157.2, 217.2, null, 618.6],
  [157.5, 217.1, null, 618.9],
  [158.1, 217.3, null, 618.9],
  [158.1, 217.2, null, 618.4],
  [158.6, 217.4, null, 618.2],
  [158.4, 217.4, null, 618.7],
  [158.7, 217.4, null, 618.7],
  [158.8, 217.7, null, 618.9],
  [159.2, 218.0, null, 618.9],
  [159.5, 218.0, null, 619.1],
  [159.5, 218.0, null, 618.6],
  [159.9, 218.3, null, 618.0],
  [160.0, 218.1, null, 617.5],
  [160.3, 218.5, null, 617.3],
  [160.8, 218.6, null, 617.1],
  [160.8, 218.6, null, 617.3],
  [160.9, 218.9, null, 617.0],
  [161.5, 219.0, null, 617.3],
  [161.4, 219.1, null, 617.5],
  [161.9, 219.1, null, 617.9],
  [162.1, 219.4, null, 618.2],
  [162.4, 219.3, null, 618.6],
  [162.7, 219.4, null, 618.4],
  [162.8, 219.5, null, 618.4],
  [162.9, 219.5, null, 618.6],
  [163.3, 219.9, null, 618.8],
  [163.4, 220.1, null, 619.3],
  [163.8, 220.4, null, 619.5],
  [164.3, 220.2, null, 619.5],
  [164.3, 220.2, null, 619.5],
  [164.6, 220.4, null, 620.2],
  [164.7, 220.7, null, 620.2],
  [164.9, 220.7, null, 620.4],
  [165.2, 221.0, null, 621.1],
  [165.5, 220.9, null, 621.3],
  [165.6, 221.0, null, 621.8],
  [166.0, 221.3, null, 622.2],
  [166.2, 221.5, null, 622.9],
  [166.5, 221.5, null, 623.1],
  [166.6, 221.6, null, 623.6],
  [167.2, 221.8, null, 623.2],
  [167.3, 221.8, null, 623.4],
  [167.4, 221.6, null, 622.5],
  [167.6, 222.0, null, 622.7],
  [168.0, 222.2, null, 622.5],
  [168.2, 222.2, null, 622.5],
  [168.6, 222.2, null, 621.8],
  [168.3, 222.8, null, 621.8],
  [169.1, 222.7, null, 621.8],
  [169.2, 222.8, null, 621.6],
  [169.4, 222.9, null, 622.0],
  [169.5, 222.9, null, 622.0],
  [169.9, 223.1, null, 622.5],
  [170.1, 223.3, null, 622.5],
  [170.5, 223.3, null, 622.9],
  [170.6, 223.6, null, 622.9],
  [170.8, 223.5, null, 623.4],
  [171.0, 223.4, null, 623.2],
  [171.4, 223.7, null, 623.1],
  [171.4, 224.2, null, 623.1],
  [171.7, 224.2, null, 622.7],
  [171.9, 224.2, null, 623.1],
  [172.0, 224.4, null, 622.7],
  [172.3, 224.4, null, 622.7],
  [172.8, 224.5, null, 622.4],
  [172.8, 224.6, null, 622.4],
  [173.1, 224.9, null, 622.0],
  [173.2, 225.1, null, 622.0],
  [173.5, 225.0, null, 621.5],
  [173.8, 225.1, null, 620.4],
  [174.2, 225.1, null, 619.7],
  [174.0, 225.3, null, 618.8],
  [174.5, 225.2, null, 618.2],
  [174.6, 225.3, null, 617.7],
  [175.0, 225.3, null, 617.3],
  [174.6, 225.7, null, 617.0],
  [175.3, 225.6, null, 617.0],
  [175.7, 225.8, null, 617.0],
  [175.8, 226.3, null, 617.0],
  [175.8, 226.1, null, 617.0],
  [176.3, 226.3, null, 617.0],
  [176.7, 226.2, null, 617.3],
  [176.9, 226.3, null, 617.5],
  [176.7, 226.4, null, 617.5],
  [177.2, 226.5, null, 617.7],
  [177.3, 226.9, null, 617.9],
  [177.7, 226.9, null, 617.9],
  [177.8, 227.1, null, 617.5],
  [178.0, 227.1, null, 617.5],
  [178.2, 227.7, null, 617.3],
  [178.4, 227.5, null, 617.5],
  [178.8, 227.5, null, 617.1],
  [178.9, 227.7, null, 617.3],
  [178.9, 228.0, null, 617.7],
  [179.4, 228.0, null, 618.0],
  [179.8, 227.9, null, 618.0],
  [179.8, 228.2, null, 618.4],
  [180.1, 228.1, null, 618.2],
  [180.2, 228.2, null, 617.7],
  [180.5, 228.4, null, 617.5],
  [180.5, 228.4, null, 617.7],
  [180.7, 228.6, null, 617.1],
  [180.9, 228.8, null, 617.5],
  [181.3, 229.0, null, 617.5],
  [181.6, 229.0, null, 618.0],
  [181.8, 228.9, null, 618.4],
  [182.0, 229.2, null, 618.9],
  [182.8, 229.2, null, 618.9],
  [182.4, 229.4, null, 619.1],
  [182.7, 230.0, null, 619.1],
  [183.0, 229.7, null, 619.3],
  [183.2, 229.9, null, 619.3],
  [183.3, 229.8, null, 619.8],
  [183.6, 229.9, null, 619.1],
  [183.7, 230.1, null, 618.6],
  [184.2, 230.3, null, 618.4],
  [184.2, 230.5, null, 617.7],
  [184.7, 230.2, null, 617.7],
  [184.5, 230.6, null, 617.1],
  [185.1, 230.8, null, 616.8],
  [185.3, 230.8, null, 615.7],
  [185.5, 230.9, null, 615.3],
  [185.6, 230.9, null, 614.4],
  [185.8, 231.0, null, 613.9],
  [186.3, 231.6, null, 613.5],
  [186.2, 231.3, null, 613.9],
  [186.5, 231.6, null, 613.7],
  [186.7, 231.7, null, 613.5],
  [186.8, 231.7, null, 613.5],
  [187.3, 232.0, null, 613.0],
  [187.4, 231.8, null, 612.3],
  [187.5, 231.9, null, 611.9],
  [187.7, 232.2, null, 611.9],
  [188.0, 232.1, null, 611.9],
  [188.0, 232.1, null, 612.3],
  [188.5, 232.3, null, 612.6],
  [188.6, 232.5, null, 612.8],
  [188.9, 232.7, null, 613.5],
  [189.1, 232.7, null, 614.4],
  [189.2, 232.9, null, 614.8],
  [189.5, 232.7, null, 615.3],
  [189.7, 232.8, null, 615.5],
  [189.8, 232.9, null, 615.9],
  [190.1, 233.1, null, 615.9],
  [190.3, 233.6, null, 615.7],
  [190.5, 233.5, null, 615.5],
  [190.5, 233.1, null, 615.1],
  [191.0, 233.3, null, 614.8],
  [191.0, 233.6, null, 614.6],
  [191.3, 233.5, null, 614.4],
  [191.4, 233.6, null, 614.4],
  [191.7, 233.7, null, 614.2],
  [191.8, 233.8, null, 614.8],
  [192.2, 233.8, null, 615.7],
  [192.7, 233.9, null, 616.6],
  [192.5, 233.9, null, 617.8],
  [193.0, 234.3, null, 618.4],
  [193.0, 234.5, null, 619.3],
  [193.3, 234.6, null, 620.2],
  [193.5, 234.5, null, 620.7],
  [193.6, 234.4, null, 620.9],
  [194.0, 234.7, null, 621.6],
  [194.1, 234.7, null, 622.0],
  [194.2, 234.9, null, 622.2],
  [194.7, 235.2, null, 622.7],
  [194.8, 235.3, null, 622.9],
  [194.9, 235.5, null, 622.9],
  [195.3, 235.3, null, 623.1],
  [195.1, 235.8, null, 622.9],
  [195.4, 235.7, null, 622.5],
  [195.6, 235.5, null, 622.2],
  [196.1, 235.5, null, 621.8],
  [196.1, 235.3, null, 621.6],
  [196.4, 235.2, null, 621.3],
  [196.6, 235.1, null, 621.3],
  [196.6, 234.6, null, 621.8],
  [196.8, 234.6, null, 622.2],
  [197.3, 234.4, null, 622.5],
  [197.3, 234.1, null, 622.5],
  [197.8, 233.6, null, 622.7],
  [197.8, 233.4, null, 622.9],
  [197.7, 233.1, null, 623.1],
  [197.9, 232.7, null, 623.6],
  [198.2, 232.6, null, 624.0],
  [198.2, 232.6, null, 623.3],
  [198.3, 232.2, null, 623.3],
  [198.4, 231.9, null, 622.9],
  [198.6, 231.7, null, 622.7],
  [198.8, 231.4, null, 622.0],
  [198.8, 231.1, null, 621.3],
  [199.1, 231.0, null, 621.1],
  [199.1, 230.8, null, 620.9],
  [199.7, 230.3, null, 620.4],
  [199.9, 230.1, null, 620.7],
  [199.9, 230.1, null, 620.7],
  [199.7, 229.9, null, 620.4],
  [200.2, 229.6, null, 620.4],
  [200.2, 229.4, null, 620.7],
  [200.3, 229.0, null, 620.0],
  [200.3, 228.4, null, 619.3],
  [200.5, 228.3, null, 619.3],
  [200.8, 227.6, null, 618.4],
  [201.0, 227.0, null, 618.2],
  [200.6, 226.8, null, 617.7],
  [201.0, 226.1, null, 617.5],
  [201.0, 225.8, null, 617.5],
  [200.9, 225.2, null, 617.5],
  [201.2, 224.9, null, 617.7],
  [201.6, 224.2, null, 617.5],
  [201.5, 223.9, null, 617.3],
  [201.7, 223.2, null, 617.3],
  [201.7, 222.9, null, 616.8],
  [201.8, 222.4, null, 617.1],
  [202.1, 222.0, null, 617.1],
  [201.9, 221.6, null, 616.8],
  [202.1, 221.2, null, 616.8],
  [201.9, 220.9, null, 616.4],
  [202.4, 220.6, null, 615.9],
  [202.6, 220.1, null, 615.9],
  [202.5, 219.9, null, 615.9],
  [202.4, 219.5, null, 615.7],
  [202.9, 219.0, null, 615.7],
  [202.9, 218.7, null, 615.5],
  [202.6, 218.6, null, 615.2],
  [203.2, 218.1, null, 614.6],
  [202.9, 218.0, null, 614.6],
  [203.1, 217.9, null, 614.1],
  [203.0, 217.5, null, 613.7],
  [203.2, 217.2, null, 613.4],
  [203.2, 216.9, null, 613.4],
  [203.3, 216.9, null, 613.0],
  [203.4, 216.5, null, 613.6],
  [203.5, 216.3, null, 613.4],
  [203.3, 216.3, null, 614.3],
  [203.5, 216.3, null, 614.5],
  [203.7, 215.9, null, 614.7],
  [203.5, 215.6, null, 615.0],
  [203.4, 215.4, null, 615.2],
  [203.8, 215.6, null, 615.4],
  [203.8, 215.1, null, 615.6],
  [203.8, 215.1, null, 615.6],
  [203.9, 215.0, null, 615.4],
  [203.9, 214.8, null, 615.0],
  [203.7, 214.7, null, 614.3],
  [204.0, 214.6, null, 614.3],
  [204.0, 214.3, null, 614.1],
  [204.0, 214.1, null, 614.1],
  [204.1, 214.3, null, 613.9],
  [204.1, 214.0, null, 614.1],
  [204.1, 213.9, null, 614.3],
  [204.3, 213.8, null, 613.9],
  [204.4, 213.8, null, 614.3],
  [204.5, 213.5, null, 614.1],
  [204.7, 213.5, null, 614.3],
  [204.5, 213.5, null, 614.3],
  [204.5, 213.5, null, 614.5],
  [204.5, 213.4, null, 614.7],
  [204.7, 213.1, null, 614.9],
  [204.6, 213.1, null, 615.2],
  [204.9, 212.9, null, 615.6],
  [204.8, 212.9, null, 616.1],
  [204.7, 212.9, null, 616.7],
  [204.7, 212.9, null, 617.4],
  [204.7, 212.5, null, 617.9],
  [204.8, 212.7, null, 619.2],
  [204.8, 212.6, null, 620.3],
  [205.1, 212.6, null, 621.5],
  [205.2, 212.8, null, 622.1],
  [205.1, 212.7, null, 623.7],
  [205.2, 212.4, null, 624.8],
  [205.2, 212.2, null, 625.5],
  [205.3, 212.2, null, 625.9],
  [205.3, 212.3, null, 626.6],
  [205.0, 212.4, null, 627.1],
  [205.4, 212.3, null, 627.7],
  [205.4, 212.1, null, 628.0],
  [205.3, 212.3, null, 628.6],
  [205.5, 212.1, null, 629.3],
  [205.4, 212.3, null, 630.0],
  [205.5, 212.0, null, 630.5],
  [205.5, 211.8, null, 631.4],
  [205.7, 211.8, null, 632.5],
  [205.8, 211.8, null, 633.6],
  [205.9, 211.9, null, 634.1],
  [205.7, 211.9, null, 635.0],
  [205.8, 211.6, null, 635.4],
  [205.9, 211.4, null, 635.7],
  [205.8, 211.0, null, 635.9],
  [205.9, 210.6, null, 634.3]
];

export const Sumatra: CurrentTempReading[] = [
  [186.4, 173.7, null, 109.6],
  [186.7, 174.1, null, 109.8],
  [186.9, 173.6, null, 109.8],
  [186.8, 173.2, null, 110.0],
  [186.2, 172.3, null, 110.3],
  [185.5, 171.1, null, 110.3],
  [184.6, 169.8, null, 110.5],
  [183.5, 168.1, null, 109.8],
  [182.3, 166.6, null, 109.6],
  [181.0, 164.8, null, 109.3],
  [179.2, 163.0, null, 109.6],
  [177.5, 161.3, null, 109.4],
  [176.0, 159.4, null, 109.4],
  [174.1, 158.0, null, 111.7],
  [172.1, 156.7, null, 119.3],
  [170.3, 155.2, null, 130.8],
  [168.7, 154.0, null, 145.3],
  [166.7, 152.8, null, 161.2],
  [165.2, 151.9, null, 177.9],
  [163.2, 151.0, null, 194.8],
  [161.3, 150.2, null, 212.2],
  [159.7, 149.4, null, 228.4],
  [157.9, 148.8, null, 243.9],
  [156.7, 148.0, null, 258.7],
  [154.8, 147.7, null, 273.4],
  [153.4, 147.0, null, 287.1],
  [151.6, 146.5, null, 299.7],
  [149.8, 146.0, null, 311.4],
  [148.6, 145.8, null, 322.9],
  [147.1, 145.4, null, 334.3],
  [145.7, 144.9, null, 345.1],
  [144.2, 144.6, null, 354.8],
  [142.6, 144.1, null, 364.8],
  [141.4, 144.0, null, 373.5],
  [140.0, 143.7, null, 381.6],
  [138.6, 143.0, null, 390.0],
  [137.3, 142.7, null, 397.7],
  [135.8, 142.9, null, 405.1],
  [134.7, 142.4, null, 412.1],
  [133.6, 142.5, null, 419.1],
  [132.2, 142.2, null, 425.7],
  [131.2, 141.8, null, 431.3],
  [130.1, 141.9, null, 436.7],
  [129.0, 141.6, null, 441.6],
  [127.9, 141.3, null, 447.0],
  [126.6, 141.4, null, 451.7],
  [125.7, 141.4, null, 456.6],
  [124.9, 141.2, null, 461.1],
  [123.8, 141.1, null, 465.8],
  [122.9, 141.0, null, 469.9],
  [121.9, 141.0, null, 474.1],
  [120.8, 140.8, null, 477.7],
  [120.4, 140.8, null, 481.1],
  [119.3, 140.9, null, 484.5],
  [118.5, 140.6, null, 487.4],
  [117.6, 140.9, null, 490.3],
  [116.9, 140.4, null, 493.2],
  [116.0, 140.4, null, 496.1],
  [115.5, 140.4, null, 498.4],
  [114.5, 140.3, null, 501.3],
  [113.9, 140.3, null, 503.7],
  [113.0, 140.4, null, 506.1],
  [112.4, 140.4, null, 508.6],
  [111.7, 140.4, null, 510.9],
  [111.0, 140.2, null, 513.3],
  [110.3, 140.3, null, 515.6],
  [109.8, 140.3, null, 517.1],
  [109.1, 140.6, null, 518.7],
  [108.4, 140.4, null, 520.1],
  [107.9, 140.5, null, 521.6],
  [107.4, 140.5, null, 523.0],
  [106.9, 140.4, null, 524.5],
  [106.4, 140.5, null, 525.9],
  [106.0, 140.7, null, 527.0],
  [105.6, 140.9, null, 527.7],
  [104.9, 140.4, null, 529.0],
  [104.5, 140.7, null, 530.6],
  [104.0, 140.3, null, 531.9],
  [103.7, 140.7, null, 533.5],
  [103.2, 140.9, null, 535.3],
  [102.6, 140.9, null, 537.1],
  [102.5, 140.8, null, 538.9],
  [101.9, 140.9, null, 540.2],
  [101.7, 141.0, null, 542.2],
  [100.9, 140.9, null, 543.6],
  [100.5, 141.1, null, 545.1],
  [100.6, 141.0, null, 546.5],
  [99.9, 140.9, null, 547.3],
  [99.8, 141.5, null, 548.7],
  [99.6, 141.1, null, 549.1],
  [99.3, 141.7, null, 550.5],
  [99.2, 141.6, null, 551.2],
  [98.6, 141.5, null, 552.1],
  [98.4, 141.8, null, 552.8],
  [98.1, 141.9, null, 554.1],
  [97.8, 141.8, null, 555.0],
  [97.8, 141.9, null, 555.5],
  [97.7, 141.8, null, 555.9],
  [97.2, 142.5, null, 556.4],
  [97.0, 142.4, null, 557.3],
  [96.7, 142.6, null, 557.7],
  [96.5, 142.4, null, 557.9],
  [96.1, 142.3, null, 557.9],
  [96.1, 142.7, null, 557.9],
  [96.0, 142.8, null, 557.9],
  [96.1, 142.7, null, 557.9],
  [95.7, 142.7, null, 557.7],
  [95.4, 142.8, null, 557.9],
  [95.3, 142.7, null, 557.9],
  [95.5, 142.9, null, 557.7],
  [95.3, 143.3, null, 557.9],
  [94.9, 142.9, null, 558.1],
  [95.1, 143.3, null, 558.1],
  [94.6, 143.4, null, 558.1],
  [94.8, 143.5, null, 557.9],
  [94.8, 143.5, null, 557.9],
  [94.9, 143.8, null, 557.9],
  [94.7, 143.9, null, 558.2],
  [94.8, 143.8, null, 558.6],
  [94.8, 144.1, null, 559.1],
  [94.4, 143.7, null, 560.2],
  [94.7, 143.9, null, 561.1],
  [94.5, 144.2, null, 562.6],
  [94.4, 143.8, null, 563.7],
  [94.3, 144.1, null, 564.2],
  [94.2, 144.1, null, 564.8],
  [94.2, 144.0, null, 565.5],
  [94.2, 144.3, null, 565.7],
  [94.3, 144.6, null, 566.2],
  [94.2, 144.3, null, 566.2],
  [94.3, 144.3, null, 566.8],
  [94.2, 144.6, null, 566.8],
  [94.0, 144.4, null, 567.3],
  [93.9, 144.6, null, 568.0],
  [93.9, 144.7, null, 568.4],
  [94.2, 144.7, null, 569.3],
  [94.3, 144.8, null, 569.5],
  [94.2, 144.9, null, 570.0],
  [94.2, 144.8, null, 570.2],
  [94.1, 145.0, null, 570.2],
  [94.4, 145.0, null, 570.0],
  [94.5, 145.0, null, 569.5],
  [94.4, 144.9, null, 569.8],
  [94.4, 145.4, null, 570.0],
  [94.5, 145.4, null, 570.9],
  [94.6, 145.0, null, 570.6],
  [94.6, 145.3, null, 571.5],
  [94.6, 145.1, null, 572.2],
  [95.0, 145.3, null, 572.9],
  [95.0, 145.5, null, 573.5],
  [95.2, 145.5, null, 574.2],
  [95.1, 145.6, null, 574.7],
  [95.1, 145.6, null, 575.3],
  [94.8, 145.9, null, 576.0],
  [95.2, 145.8, null, 576.9],
  [95.4, 145.9, null, 577.6],
  [95.7, 145.9, null, 578.3],
  [95.6, 145.9, null, 578.5],
  [95.4, 145.9, null, 579.4],
  [95.7, 145.9, null, 579.6],
  [95.5, 146.0, null, 580.1],
  [96.0, 146.2, null, 580.3],
  [95.8, 146.6, null, 581.0],
  [96.0, 146.8, null, 581.9],
  [96.1, 147.2, null, 582.5],
  [96.0, 147.4, null, 583.2],
  [96.4, 147.7, null, 583.2],
  [96.5, 148.2, null, 583.4],
  [96.5, 149.0, null, 583.6],
  [96.7, 149.4, null, 584.1],
  [96.8, 150.1, null, 584.1],
  [97.2, 150.2, null, 584.3],
  [97.3, 151.2, null, 584.5],
  [97.4, 151.8, null, 584.7],
  [97.6, 152.5, null, 584.5],
  [97.6, 153.6, null, 585.2],
  [97.7, 154.3, null, 585.6],
  [98.1, 155.7, null, 585.6],
  [98.6, 156.4, null, 586.1],
  [98.3, 157.6, null, 586.6],
  [98.7, 158.2, null, 586.3],
  [99.0, 159.3, null, 586.8],
  [99.2, 160.1, null, 586.5],
  [99.6, 161.0, null, 586.8],
  [99.3, 161.9, null, 587.0],
  [99.6, 163.0, null, 587.0],
  [100.0, 163.8, null, 586.5],
  [100.1, 164.9, null, 586.5],
  [100.5, 165.8, null, 586.1],
  [100.5, 166.4, null, 585.8],
  [100.7, 167.3, null, 585.6],
  [100.7, 168.3, null, 585.9],
  [101.3, 169.0, null, 586.1],
  [101.6, 169.7, null, 586.3],
  [101.5, 170.2, null, 586.3],
  [102.0, 171.0, null, 586.5],
  [102.0, 171.7, null, 586.7],
  [102.4, 172.8, null, 586.5],
  [102.8, 173.0, null, 586.5],
  [102.8, 173.8, null, 586.5],
  [103.5, 174.3, null, 586.8],
  [103.5, 175.2, null, 587.0],
  [103.7, 175.9, null, 587.2],
  [104.0, 176.4, null, 587.7],
  [104.2, 177.0, null, 587.7],
  [104.6, 177.5, null, 587.5],
  [104.6, 178.0, null, 587.5],
  [105.2, 178.5, null, 587.5],
  [105.2, 179.1, null, 587.2],
  [105.6, 179.4, null, 587.7],
  [105.8, 180.2, null, 587.7],
  [106.1, 180.6, null, 587.5],
  [106.7, 181.1, null, 587.5],
  [106.5, 181.3, null, 587.7],
  [106.9, 181.9, null, 587.7],
  [106.9, 182.4, null, 588.1],
  [107.5, 182.8, null, 588.6],
  [107.7, 183.3, null, 589.0],
  [107.7, 183.6, null, 589.1],
  [107.9, 184.4, null, 589.7],
  [108.4, 184.6, null, 589.7],
  [108.9, 184.9, null, 590.4],
  [109.2, 185.3, null, 590.6],
  [109.3, 185.6, null, 590.6],
  [109.5, 186.1, null, 590.9],
  [109.9, 186.2, null, 591.5],
  [110.1, 186.6, null, 591.5],
  [110.4, 187.0, null, 591.8],
  [110.7, 187.6, null, 592.0],
  [111.0, 187.6, null, 591.8],
  [111.0, 188.2, null, 592.2],
  [111.1, 188.3, null, 592.4],
  [111.6, 188.8, null, 592.4],
  [112.0, 188.9, null, 592.7],
  [112.4, 189.2, null, 592.9],
  [112.6, 189.6, null, 593.3],
  [112.9, 189.8, null, 593.1],
  [113.1, 190.0, null, 593.3],
  [113.3, 190.4, null, 593.6],
  [113.6, 190.3, null, 593.1],
  [113.8, 190.9, null, 592.7],
  [114.1, 191.0, null, 592.7],
  [114.6, 191.5, null, 592.7],
  [114.8, 191.7, null, 592.7],
  [114.9, 192.0, null, 592.7],
  [115.5, 192.1, null, 592.9],
  [115.5, 192.5, null, 593.1],
  [115.7, 192.8, null, 592.9],
  [116.1, 193.1, null, 592.7],
  [116.2, 193.4, null, 592.2],
  [116.5, 193.4, null, 592.4],
  [116.9, 193.7, null, 592.0],
  [117.4, 193.9, null, 592.2],
  [117.7, 193.9, null, 592.2],
  [117.8, 194.5, null, 592.0],
  [118.1, 194.5, null, 592.2],
  [118.5, 194.7, null, 592.0],
  [118.5, 194.9, null, 591.8],
  [118.9, 195.4, null, 591.8],
  [119.2, 195.5, null, 591.5],
  [119.2, 195.6, null, 591.5],
  [119.8, 195.7, null, 592.0],
  [120.0, 195.8, null, 592.2],
  [120.4, 196.3, null, 592.2],
  [120.7, 196.3, null, 592.9],
  [121.0, 196.8, null, 593.1],
  [121.4, 196.4, null, 593.6],
  [121.7, 196.9, null, 594.0],
  [121.8, 197.1, null, 594.5],
  [121.7, 197.5, null, 594.9],
  [122.2, 197.7, null, 595.6],
  [122.5, 197.7, null, 595.8],
  [122.8, 198.1, null, 596.5],
  [123.2, 198.2, null, 596.7],
  [123.4, 198.5, null, 596.7],
  [123.8, 198.6, null, 596.5],
  [123.8, 198.8, null, 596.2],
  [124.2, 198.5, null, 596.2],
  [124.7, 199.0, null, 596.9],
  [125.0, 199.2, null, 597.4],
  [125.4, 199.6, null, 597.1],
  [125.4, 199.5, null, 597.4],
  [126.1, 199.8, null, 597.4],
  [126.1, 200.0, null, 596.9],
  [126.6, 200.2, null, 597.1],
  [126.3, 200.7, null, 596.7],
  [127.1, 200.8, null, 597.1],
  [127.5, 200.7, null, 597.1],
  [127.4, 200.9, null, 597.1],
  [128.0, 201.1, null, 597.1],
  [128.2, 201.0, null, 597.6],
  [128.3, 201.4, null, 597.8],
  [128.6, 201.6, null, 598.0],
  [129.1, 201.7, null, 598.9],
  [129.0, 201.7, null, 598.9],
  [129.5, 202.1, null, 599.8],
  [129.7, 202.2, null, 600.7],
  [130.2, 202.3, null, 601.4],
  [130.3, 202.6, null, 602.3],
  [130.6, 202.8, null, 603.0],
  [131.0, 202.9, null, 603.4],
  [131.3, 202.9, null, 603.2],
  [131.6, 203.2, null, 603.2],
  [131.9, 203.4, null, 603.6],
  [132.3, 203.4, null, 603.6],
  [132.4, 203.5, null, 604.1],
  [132.6, 203.6, null, 604.3],
  [133.1, 204.0, null, 605.2],
  [133.7, 204.1, null, 606.1],
  [133.9, 204.2, null, 606.1],
  [133.7, 204.5, null, 606.5],
  [134.2, 204.8, null, 606.8],
  [134.6, 204.7, null, 606.5],
  [134.6, 205.2, null, 607.0],
  [135.2, 205.3, null, 607.2],
  [135.3, 205.4, null, 606.8],
  [135.8, 205.7, null, 606.5],
  [135.9, 205.7, null, 606.1],
  [136.3, 206.0, null, 605.9],
  [136.6, 206.0, null, 605.2],
  [137.0, 206.7, null, 604.7],
  [137.1, 206.6, null, 604.3],
  [137.6, 206.5, null, 604.5],
  [137.9, 206.7, null, 604.5],
  [137.9, 206.6, null, 604.3],
  [138.3, 207.1, null, 604.1],
  [138.6, 207.2, null, 604.1],
  [138.9, 207.2, null, 603.8],
  [139.0, 207.5, null, 603.4],
  [139.4, 207.8, null, 603.2],
  [139.5, 207.8, null, 603.2],
  [140.3, 207.8, null, 602.7],
  [140.1, 207.9, null, 602.7],
  [140.5, 208.2, null, 602.9],
  [141.0, 208.4, null, 602.9],
  [141.2, 208.5, null, 603.2],
  [141.3, 208.6, null, 603.2],
  [141.6, 208.8, null, 603.8],
  [142.0, 209.0, null, 604.1],
  [142.2, 208.9, null, 604.1],
  [142.5, 209.3, null, 603.9],
  [143.2, 209.3, null, 603.9],
  [143.1, 209.7, null, 603.9],
  [143.6, 210.0, null, 604.1],
  [144.1, 209.7, null, 605.2],
  [144.1, 210.1, null, 605.9],
  [144.5, 210.2, null, 606.8],
  [144.7, 210.1, null, 607.2],
  [145.2, 210.3, null, 607.9],
  [145.1, 210.3, null, 607.9],
  [145.4, 210.8, null, 607.7],
  [145.6, 210.7, null, 608.1],
  [146.1, 210.8, null, 608.4],
  [146.2, 211.2, null, 608.6],
  [146.4, 211.0, null, 608.4],
  [146.9, 211.2, null, 608.8],
  [147.0, 211.4, null, 609.3],
  [147.5, 211.4, null, 609.3],
  [147.4, 211.5, null, 609.5],
  [148.0, 211.7, null, 609.0],
  [148.3, 212.0, null, 608.6],
  [148.4, 211.9, null, 607.9],
  [149.0, 212.1, null, 607.5],
  [149.0, 212.4, null, 607.0],
  [149.4, 212.6, null, 606.6],
  [149.6, 212.7, null, 605.9],
  [149.7, 213.0, null, 605.4],
  [150.2, 213.1, null, 605.0],
  [150.7, 213.1, null, 605.0],
  [150.8, 212.9, null, 605.0],
  [151.1, 213.3, null, 605.0],
  [151.5, 213.4, null, 605.0],
  [151.7, 213.5, null, 604.5],
  [152.1, 213.7, null, 604.3],
  [152.1, 213.8, null, 604.3],
  [152.6, 214.2, null, 603.9],
  [152.8, 214.1, null, 603.6],
  [153.2, 214.0, null, 603.9],
  [153.4, 214.4, null, 603.4],
  [153.7, 214.6, null, 603.9],
  [154.0, 214.8, null, 603.9],
  [154.3, 214.6, null, 604.1],
  [154.6, 215.0, null, 604.1],
  [154.8, 215.2, null, 603.6],
  [155.1, 215.2, null, 604.1],
  [155.3, 215.4, null, 604.1],
  [155.9, 215.6, null, 604.5],
  [155.9, 215.6, null, 604.8],
  [156.1, 215.8, null, 605.0],
  [156.5, 216.0, null, 605.0],
  [156.8, 216.1, null, 605.4],
  [157.2, 216.4, null, 606.3],
  [157.5, 216.4, null, 606.6],
  [157.8, 216.6, null, 607.2],
  [158.0, 216.8, null, 607.9],
  [158.3, 217.0, null, 607.5],
  [158.5, 217.0, null, 608.6],
  [159.0, 217.2, null, 608.8],
  [159.2, 217.0, null, 608.6],
  [159.6, 217.2, null, 608.6],
  [159.7, 217.4, null, 608.4],
  [160.0, 217.6, null, 608.4],
  [160.4, 217.7, null, 608.6],
  [160.6, 218.1, null, 608.4],
  [161.4, 218.1, null, 608.6],
  [161.1, 218.1, null, 608.8],
  [161.5, 218.3, null, 609.0],
  [161.8, 218.0, null, 609.2],
  [161.9, 218.5, null, 609.5],
  [162.6, 218.6, null, 609.9],
  [162.8, 218.6, null, 610.8],
  [162.9, 218.8, null, 611.0],
  [163.2, 218.8, null, 611.3],
  [163.7, 219.2, null, 611.3],
  [164.0, 219.1, null, 611.3],
  [163.8, 219.1, null, 611.3],
  [164.6, 218.9, null, 611.5],
  [164.4, 219.2, null, 611.7],
  [164.9, 219.2, null, 611.9],
  [165.4, 219.7, null, 611.9],
  [165.5, 219.6, null, 612.6],
  [165.9, 219.8, null, 612.6],
  [165.9, 220.0, null, 613.3],
  [166.2, 220.1, null, 613.3],
  [166.6, 220.3, null, 614.2],
  [167.0, 220.2, null, 614.4],
  [167.0, 220.8, null, 615.1],
  [167.3, 220.8, null, 615.3],
  [167.8, 220.8, null, 616.0],
  [168.1, 221.2, null, 616.5],
  [168.5, 221.5, null, 616.9],
  [168.7, 221.3, null, 617.6],
  [169.0, 221.2, null, 617.6],
  [169.2, 221.6, null, 618.0],
  [169.3, 221.9, null, 618.2],
  [169.5, 222.1, null, 618.0],
  [170.1, 222.0, null, 618.5],
  [170.3, 222.1, null, 618.2],
  [170.6, 222.1, null, 618.5],
  [171.0, 222.2, null, 618.2],
  [171.1, 222.5, null, 618.0],
  [171.5, 222.7, null, 617.8],
  [171.6, 222.8, null, 617.8],
  [172.1, 222.9, null, 617.8],
  [172.3, 222.8, null, 617.6],
  [172.4, 223.3, null, 618.2],
  [173.1, 223.2, null, 617.8],
  [172.9, 223.4, null, 618.0],
  [173.4, 223.7, null, 617.8],
  [173.4, 223.8, null, 618.0],
  [173.9, 224.2, null, 617.3],
  [174.3, 224.0, null, 616.9],
  [174.4, 224.5, null, 616.4],
  [174.8, 224.1, null, 616.2],
  [175.2, 224.5, null, 615.1],
  [175.3, 224.6, null, 614.9],
  [175.5, 224.7, null, 614.4],
  [175.9, 224.8, null, 614.4],
  [176.1, 224.8, null, 614.4],
  [176.3, 225.4, null, 614.0],
  [176.7, 225.2, null, 614.2],
  [176.9, 225.5, null, 614.0],
  [177.5, 225.3, null, 614.0],
  [177.3, 225.3, null, 613.7],
  [177.5, 225.9, null, 613.5],
  [178.2, 225.9, null, 613.5],
  [178.3, 225.8, null, 613.3],
  [178.6, 226.0, null, 613.3],
  [179.1, 226.4, null, 613.5],
  [179.2, 226.2, null, 613.3],
  [179.5, 226.5, null, 614.0],
  [179.6, 226.6, null, 613.8],
  [180.0, 226.9, null, 613.8],
  [180.3, 226.6, null, 614.0],
  [180.4, 227.0, null, 614.0],
  [180.6, 227.0, null, 614.4],
  [181.2, 227.2, null, 614.5],
  [181.5, 227.1, null, 614.7],
  [181.6, 227.4, null, 614.9],
  [181.6, 227.4, null, 615.1],
  [182.5, 228.1, null, 615.8],
  [182.5, 227.7, null, 616.3],
  [182.7, 227.6, null, 616.7],
  [183.2, 227.8, null, 617.2],
  [183.4, 228.1, null, 617.2],
  [183.7, 228.2, null, 617.6],
  [183.9, 228.2, null, 617.6],
  [184.2, 228.3, null, 617.4],
  [184.5, 228.8, null, 617.6],
  [184.5, 229.1, null, 618.3],
  [185.1, 228.8, null, 618.8],
  [185.5, 229.2, null, 619.0],
  [185.4, 229.2, null, 618.8],
  [186.0, 229.1, null, 618.8],
  [186.2, 229.2, null, 618.6],
  [186.4, 229.3, null, 619.0],
  [186.7, 229.8, null, 619.2],
  [186.9, 229.6, null, 619.7],
  [187.3, 229.9, null, 620.1],
  [187.5, 230.1, null, 620.3],
  [187.9, 230.0, null, 620.8],
  [188.1, 230.3, null, 621.2],
  [188.2, 230.3, null, 621.0],
  [188.6, 230.5, null, 621.4],
  [189.0, 230.5, null, 621.5],
  [189.1, 230.7, null, 622.1],
  [189.3, 230.8, null, 622.6],
  [189.7, 231.1, null, 622.1],
  [190.0, 230.9, null, 622.1],
  [190.3, 231.1, null, 622.3],
  [190.6, 231.4, null, 621.7],
  [190.6, 231.3, null, 621.2],
  [191.0, 231.6, null, 621.2],
  [191.4, 231.6, null, 621.0],
  [191.2, 231.8, null, 620.3],
  [191.7, 231.9, null, 619.9],
  [191.8, 232.2, null, 620.3],
  [192.0, 232.2, null, 620.5],
  [192.4, 232.5, null, 621.0],
  [192.6, 232.7, null, 620.7],
  [192.9, 232.6, null, 621.2],
  [193.2, 232.6, null, 620.7],
  [193.1, 232.9, null, 620.7],
  [193.4, 232.8, null, 620.3],
  [194.0, 233.1, null, 619.8],
  [194.2, 233.1, null, 619.2],
  [194.4, 233.5, null, 618.5],
  [194.5, 233.5, null, 618.0],
  [194.9, 232.9, null, 617.8],
  [195.0, 232.9, null, 617.8],
  [195.1, 232.3, null, 617.3],
  [195.3, 231.6, null, 617.8],
  [195.4, 231.2, null, 618.5],
  [195.9, 230.3, null, 618.9],
  [195.9, 229.5, null, 619.3],
  [196.0, 229.0, null, 619.8],
  [196.1, 228.2, null, 620.0],
  [196.6, 227.2, null, 620.9],
  [196.5, 226.8, null, 621.4],
  [196.3, 226.1, null, 621.8],
  [196.8, 224.9, null, 622.3],
  [197.0, 224.4, null, 622.7],
  [197.0, 223.9, null, 623.0],
  [197.0, 223.1, null, 623.2],
  [197.1, 222.3, null, 623.4],
  [197.1, 221.7, null, 623.6],
  [197.1, 220.7, null, 623.9],
  [197.3, 220.6, null, 624.1],
  [197.6, 220.0, null, 624.1],
  [197.8, 219.5, null, 624.8],
  [197.7, 218.4, null, 625.2],
  [198.1, 218.2, null, 625.2],
  [197.8, 217.7, null, 625.9],
  [197.9, 217.0, null, 626.1],
  [198.3, 216.8, null, 626.4],
  [198.3, 216.2, null, 627.0],
  [198.4, 215.9, null, 627.5],
  [198.6, 215.4, null, 628.2],
  [198.7, 215.1, null, 628.9],
  [198.7, 214.7, null, 629.3],
  [199.1, 214.3, null, 629.3],
  [198.8, 214.0, null, 628.9],
  [199.0, 213.7, null, 629.1],
  [199.1, 213.6, null, 629.1],
  [199.2, 213.2, null, 629.1],
  [199.3, 213.0, null, 629.5],
  [199.4, 212.4, null, 630.2],
  [199.4, 212.3, null, 630.4],
  [199.4, 211.9, null, 630.6],
  [199.4, 211.7, null, 631.3],
  [199.9, 211.5, null, 631.1],
  [199.8, 211.4, null, 631.3],
  [200.0, 210.9, null, 631.1],
  [200.1, 210.9, null, 631.3],
  [200.1, 211.1, null, 631.3],
  [200.0, 210.5, null, 631.3],
  [200.3, 210.5, null, 631.3],
  [200.4, 210.4, null, 631.8],
  [200.5, 210.0, null, 631.8],
  [200.6, 209.8, null, 632.0],
  [200.8, 209.8, null, 631.5],
  [200.6, 209.5, null, 631.8],
  [200.8, 209.9, null, 631.5],
  [200.9, 209.5, null, 631.7],
  [201.1, 209.5, null, 631.5],
  [201.2, 209.4, null, 631.7],
  [201.2, 209.3, null, 631.7],
  [201.4, 209.6, null, 631.3],
  [201.5, 209.3, null, 631.5],
  [201.5, 209.1, null, 631.3],
  [201.6, 208.9, null, 631.5],
  [201.6, 209.0, null, 631.7],
  [201.9, 208.8, null, 631.3],
  [201.8, 208.8, null, 631.0],
  [201.9, 208.8, null, 631.0],
  [201.9, 208.9, null, 630.6],
  [202.1, 208.7, null, 630.8],
  [202.0, 208.8, null, 630.8],
  [202.0, 208.7, null, 630.6],
  [202.3, 208.7, null, 630.8],
  [202.4, 208.7, null, 631.0],
  [202.4, 208.4, null, 631.0],
  [202.4, 208.6, null, 631.3],
  [202.5, 208.2, null, 631.3],
  [202.6, 208.3, null, 631.0],
  [202.6, 208.3, null, 631.3],
  [202.5, 208.4, null, 631.0],
  [203.0, 208.3, null, 630.8],
  [203.0, 208.2, null, 630.8],
  [203.0, 208.4, null, 630.6],
  [203.0, 208.4, null, 630.4],
  [203.1, 208.2, null, 631.1],
  [203.0, 208.3, null, 631.1],
  [203.0, 208.2, null, 631.3],
  [203.4, 208.0, null, 631.5],
  [203.2, 208.3, null, 631.5],
  [203.4, 208.3, null, 631.5],
  [203.3, 208.3, null, 631.7],
  [203.6, 208.4, null, 631.7],
  [203.4, 208.3, null, 632.0],
  [203.4, 208.1, null, 632.4],
  [203.6, 208.0, null, 633.1],
  [203.6, 208.0, null, 633.3],
  [203.9, 208.3, null, 633.8],
  [203.9, 208.2, null, 634.2],
  [203.8, 208.2, null, 634.2],
  [203.9, 208.2, null, 634.9],
  [203.9, 208.2, null, 634.9],
  [204.1, 207.9, null, 635.1],
  [204.1, 208.2, null, 635.3],
  [204.4, 208.0, null, 635.3],
  [204.2, 208.2, null, 635.6],
  [204.5, 208.2, null, 636.0],
  [204.3, 208.0, null, 636.7],
  [204.6, 208.1, null, 636.9],
  [204.5, 208.1, null, 637.6],
  [204.8, 207.9, null, 637.8],
  [204.6, 208.2, null, 638.3],
  [204.6, 207.8, null, 638.9],
  [204.9, 208.1, null, 639.6],
  [204.9, 208.1, null, 639.8],
  [205.0, 207.7, null, 640.1],
  [204.9, 208.2, null, 640.3],
  [205.0, 208.1, null, 640.7],
  [205.0, 208.2, null, 639.8],
  [205.1, 208.2, null, 639.8],
  [205.2, 207.8, null, 639.8],
  [205.1, 207.8, null, 639.6],
  [205.2, 208.1, null, 639.4],
  [205.5, 207.8, null, 639.2],
  [205.5, 208.2, null, 639.4],
  [205.4, 208.3, null, 639.6],
  [205.6, 208.1, null, 639.4],
  [205.8, 207.9, null, 639.4],
  [206.1, 207.9, null, 639.6],
  [205.9, 207.7, null, 639.4],
  [205.7, 207.7, null, 639.6],
  [206.1, 208.0, null, 639.6],
  [205.8, 207.7, null, 639.8],
  [206.2, 207.9, null, 639.2],
  [206.0, 207.9, null, 639.4],
  [206.2, 207.6, null, 639.0],
  [206.3, 207.6, null, 639.0],
  [206.6, 207.6, null, 638.7],
  [206.4, 207.7, null, 639.0],
  [206.3, 207.5, null, 639.0],
  [206.6, 207.9, null, 639.2],
  [206.7, 207.8, null, 638.9],
  [206.8, 207.6, null, 639.6],
  [206.9, 207.6, null, 639.6],
  [206.9, 207.6, null, 639.6],
  [206.9, 207.7, null, 639.4],
  [206.9, 207.6, null, 638.7],
  [207.1, 207.7, null, 638.0],
  [207.0, 207.7, null, 637.1],
  [207.4, 207.7, null, 636.9],
  [207.4, 207.7, null, 636.2],
  [207.3, 207.7, null, 635.6],
  [207.6, 207.8, null, 634.0],
  [207.8, 208.0, null, 633.6],
  [207.8, 208.0, null, 633.1],
  [207.7, 208.0, null, 632.6],
  [207.7, 207.9, null, 632.4],
  [207.7, 208.0, null, 632.2],
  [208.2, 207.9, null, 632.4],
  [208.0, 208.0, null, 632.4],
  [208.2, 208.0, null, 632.9],
  [208.0, 208.1, null, 632.4],
  [208.4, 208.0, null, 632.0],
  [208.5, 207.9, null, 632.0],
  [208.7, 208.1, null, 631.1]
];

export const Mexico: CurrentTempReading[] = [
  [225.4, 251.1, 323.2, null],
  [224.2, 251.4, 323.3, null],
  [226.6, 252.4, 322.8, null],
  [226.4, 252.5, 323.5, null],
  [225.8, 251.8, 323.6, null],
  [223.8, 250.3, 323.8, null],
  [222.6, 249.6, 323.8, null],
  [220.7, 248.3, 323.4, null],
  [220.3, 246.4, 323.6, null],
  [215.7, 245.2, 323.8, null],
  [216.0, 244.1, 323.9, null],
  [213.1, 242.7, 324.5, null],
  [211.2, 243.1, 324.7, null],
  [208.2, 242.8, 324.3, null],
  [206.9, 241.7, 324.3, null],
  [205.8, 242.3, 324.5, null],
  [202.3, 242.3, 324.5, null],
  [202.5, 242.1, 325.1, null],
  [200.0, 241.9, 325.5, null],
  [199.6, 240.9, 325.6, null],
  [197.9, 240.7, 325.1, null],
  [195.6, 241.7, 325.2, null],
  [193.7, 241.6, 326.1, null],
  [193.3, 241.4, 326.2, null],
  [191.5, 241.3, 325.7, null],
  [189.9, 241.2, 326.4, null],
  [187.7, 240.9, 326.6, null],
  [187.9, 240.3, 326.8, null],
  [186.4, 240.2, 327.0, null],
  [184.1, 241.1, 327.0, null],
  [182.5, 241.1, 327.2, null],
  [181.0, 240.0, 326.8, null],
  [182.1, 239.9, 327.0, null],
  [179.6, 240.8, 327.6, null],
  [179.2, 240.7, 327.8, null],
  [177.7, 240.8, 327.5, null],
  [176.0, 240.7, 327.5, null],
  [175.2, 240.6, 328.3, null],
  [172.9, 239.7, 328.3, null],
  [173.1, 239.5, 327.9, null],
  [170.3, 240.1, 328.1, null],
  [170.7, 239.5, 328.9, null],
  [168.9, 240.4, 328.9, null],
  [167.5, 240.3, 328.9, null],
  [168.0, 239.8, 328.5, null],
  [166.1, 240.2, 329.4, null],
  [164.3, 239.7, 329.5, null],
  [163.9, 239.7, 329.6, null],
  [162.9, 239.0, 329.8, null],
  [162.5, 239.8, 330.0, null],
  [162.4, 239.7, 329.4, null],
  [160.2, 239.3, 330.3, null],
  [159.0, 240.1, 329.7, null],
  [159.4, 239.5, 330.5, null],
  [157.7, 239.1, 330.6, null],
  [155.6, 239.1, 330.5, null],
  [156.5, 239.9, 331.0, null],
  [155.3, 239.4, 331.1, null],
  [154.7, 239.5, 331.3, null],
  [153.6, 239.4, 331.4, null],
  [152.4, 239.3, 331.0, null],
  [152.1, 239.3, 331.7, null],
  [150.2, 238.7, 331.9, null],
  [149.5, 238.8, 332.1, null],
  [150.1, 239.0, 332.1, null],
  [149.8, 239.6, 331.7, null],
  [148.2, 238.8, 331.8, null],
  [147.8, 238.7, 332.6, null],
  [145.9, 238.5, 332.8, null],
  [145.7, 238.7, 333.0, null],
  [144.6, 238.4, 333.0, null],
  [145.9, 238.7, 333.1, null],
  [142.4, 238.5, 333.3, null],
  [143.1, 238.6, 333.5, null],
  [142.4, 239.5, 333.6, null],
  [143.9, 239.1, 333.1, null],
  [140.4, 238.7, 333.8, null],
  [140.6, 239.0, 333.9, null],
  [140.0, 238.4, 333.5, null],
  [138.4, 239.4, 333.7, null],
  [138.1, 239.0, 333.7, null],
  [138.6, 239.0, 333.9, null],
  [137.5, 238.9, 334.6, null],
  [138.0, 238.2, 334.3, null],
  [136.7, 238.7, 335.0, null],
  [137.4, 238.5, 334.9, null],
  [134.6, 239.1, 335.2, null],
  [136.0, 238.4, 334.6, null],
  [135.0, 239.0, 334.9, null],
  [133.8, 239.0, 335.7, null],
  [132.8, 238.5, 335.9, null],
  [133.2, 237.9, 335.9, null],
  [133.1, 238.8, 335.5, null],
  [132.9, 238.3, 336.2, null],
  [132.1, 238.3, 336.4, null],
  [131.8, 238.3, 335.9, null],
  [130.6, 238.6, 336.6, null],
  [131.0, 237.5, 336.2, null],
  [131.3, 238.5, 336.9, null],
  [132.4, 238.2, 337.0, null],
  [130.8, 237.5, 336.9, null],
  [127.9, 237.7, 337.4, null],
  [128.6, 237.5, 337.5, null],
  [129.6, 237.3, 337.0, null],
  [128.9, 237.8, 337.8, null],
  [127.9, 237.8, 338.1, null],
  [127.3, 237.8, 338.0, null],
  [127.8, 237.2, 338.1, null],
  [128.2, 237.8, 337.7, null],
  [126.5, 237.3, 338.4, null],
  [129.0, 237.1, 338.6, null],
  [126.6, 237.3, 338.6, null],
  [125.8, 237.1, 338.9, null],
  [128.4, 237.2, 338.4, null],
  [124.4, 237.3, 338.5, null],
  [126.4, 237.1, 339.5, null],
  [127.1, 237.8, 339.4, null],
  [125.8, 237.6, 339.5, null],
  [125.6, 237.6, 339.7, null],
  [122.8, 237.8, 339.3, null],
  [123.2, 237.8, 339.6, null],
  [124.2, 238.0, 339.5, null],
  [122.2, 237.2, 340.3, null],
  [122.9, 237.4, 339.7, null],
  [122.5, 237.5, 340.5, null],
  [122.6, 237.1, 340.6, null],
  [122.4, 237.8, 340.2, null],
  [121.8, 237.1, 340.8, null],
  [121.6, 237.7, 341.1, null],
  [122.4, 237.8, 341.1, null],
  [123.9, 237.4, 341.2, null],
  [124.6, 237.7, 341.0, null],
  [122.3, 237.8, 341.6, null],
  [123.2, 237.1, 341.6, null],
  [120.9, 238.1, 341.0, null],
  [122.0, 237.2, 342.0, null],
  [123.6, 237.6, 341.4, null],
  [121.4, 238.1, 342.3, null],
  [121.6, 237.2, 342.1, null],
  [119.6, 237.7, 342.4, null],
  [121.1, 237.6, 342.5, null],
  [120.3, 237.7, 342.8, null],
  [120.7, 237.8, 343.0, null],
  [120.7, 237.3, 342.9, null],
  [121.6, 238.3, 342.8, null],
  [121.5, 237.8, 343.3, null],
  [121.1, 237.3, 342.9, null],
  [121.2, 237.9, 343.5, null],
  [120.7, 238.5, 343.6, null],
  [119.8, 237.8, 343.1, null],
  [120.9, 237.6, 344.0, null],
  [119.8, 238.5, 344.1, null],
  [119.4, 238.7, 344.4, null],
  [119.9, 238.7, 344.4, null],
  [120.2, 238.6, 344.5, null],
  [120.9, 238.5, 344.6, null],
  [120.2, 238.3, 344.7, null],
  [119.8, 238.6, 344.7, null],
  [121.7, 238.4, 344.8, null],
  [122.2, 238.7, 345.2, null],
  [121.2, 238.7, 345.3, null],
  [118.8, 237.8, 345.3, null],
  [120.9, 238.0, 345.5, null],
  [120.9, 238.7, 344.9, null],
  [120.8, 238.4, 345.8, null],
  [120.3, 238.8, 345.9, null],
  [120.0, 238.8, 346.1, null],
  [121.4, 238.8, 345.7, null],
  [121.8, 237.8, 346.2, null],
  [121.1, 238.2, 346.4, null],
  [120.2, 238.2, 346.5, null],
  [120.8, 237.9, 346.6, null],
  [120.0, 237.8, 346.1, null],
  [121.4, 238.3, 346.8, null],
  [121.4, 238.4, 346.6, null],
  [120.7, 237.9, 347.1, null],
  [119.9, 238.0, 347.2, null],
  [120.9, 238.6, 347.1, null],
  [120.1, 239.2, 347.4, null],
  [120.8, 238.7, 347.5, null],
  [120.4, 239.1, 347.7, null],
  [121.2, 238.2, 347.3, null],
  [120.8, 238.7, 347.6, null],
  [120.7, 239.3, 348.1, null],
  [121.0, 239.4, 348.1, null],
  [121.8, 239.4, 348.3, null],
  [121.5, 238.7, 347.8, null],
  [121.3, 238.6, 347.9, null],
  [122.2, 238.6, 348.5, null],
  [122.8, 238.5, 348.2, null],
  [121.2, 238.5, 348.8, null],
  [122.9, 239.6, 348.9, null],
  [122.7, 239.6, 348.9, null],
  [122.1, 239.6, 349.1, null],
  [120.7, 239.3, 348.6, null],
  [121.4, 239.3, 348.6, null],
  [121.7, 239.3, 349.4, null],
  [122.0, 239.2, 349.5, null],
  [121.5, 239.8, 349.6, null],
  [121.8, 239.0, 349.6, null],
  [122.2, 240.1, 349.6, null],
  [121.6, 239.2, 350.0, null],
  [122.8, 240.2, 350.2, null],
  [124.3, 239.8, 350.1, null],
  [123.0, 240.2, 350.3, null],
  [123.4, 239.9, 350.5, null],
  [122.3, 240.3, 350.6, null],
  [121.9, 239.3, 350.5, null],
  [123.6, 239.5, 350.8, null],
  [123.9, 239.6, 350.9, null],
  [124.1, 240.6, 350.9, null],
  [124.6, 239.6, 351.0, null],
  [123.9, 240.6, 351.1, null],
  [123.2, 239.6, 350.7, null],
  [123.6, 239.6, 352.3, null],
  [124.9, 240.3, 351.5, null],
  [124.4, 240.8, 351.5, null],
  [123.0, 240.9, 351.6, null],
  [124.3, 240.5, 351.8, null],
  [124.4, 241.0, 351.8, null],
  [125.1, 240.5, 352.3, null],
  [124.4, 240.7, 352.1, null],
  [123.8, 240.6, 352.2, null],
  [124.3, 240.8, 352.3, null],
  [124.4, 240.8, 352.3, null],
  [125.8, 240.9, 352.6, null],
  [125.5, 240.6, 352.5, null],
  [125.8, 241.0, 352.4, null],
  [126.6, 241.1, 352.4, null],
  [125.9, 240.9, 352.6, null],
  [127.7, 241.2, 353.1, null],
  [126.9, 241.7, 353.1, null],
  [127.7, 241.1, 353.2, null],
  [126.0, 241.0, 353.3, null],
  [125.9, 241.4, 352.7, null],
  [128.4, 241.4, 353.5, null],
  [126.5, 241.4, 353.6, null],
  [127.8, 241.7, 353.6, null],
  [127.8, 241.5, 353.6, null],
  [126.4, 241.6, 353.9, null],
  [130.2, 241.7, 353.3, null],
  [126.0, 241.9, 354.0, null],
  [126.8, 241.9, 353.6, null],
  [127.2, 241.4, 354.3, null],
  [128.8, 241.8, 354.4, null],
  [127.3, 241.7, 354.3, null],
  [127.7, 241.6, 354.7, null],
  [128.3, 242.4, 354.1, null],
  [129.5, 242.5, 354.7, null],
  [130.4, 242.5, 354.8, null],
  [129.1, 241.9, 354.9, null],
  [131.0, 242.5, 354.9, null],
  [128.8, 242.7, 355.1, null],
  [129.7, 242.1, 354.9, null],
  [129.6, 242.7, 355.2, null],
  [131.2, 242.7, 355.3, null],
  [129.5, 242.8, 355.5, null],
  [128.9, 242.3, 354.8, null],
  [130.1, 242.5, 355.3, null],
  [129.5, 242.6, 355.3, null],
  [130.6, 243.2, 355.8, null],
  [130.6, 243.7, 355.3, null],
  [130.9, 243.2, 355.3, null],
  [131.9, 243.5, 355.4, null],
  [132.6, 243.0, 355.5, null],
  [132.3, 244.0, 356.0, null],
  [131.0, 243.0, 356.2, null],
  [133.2, 243.1, 356.3, null],
  [132.2, 243.9, 356.3, null],
  [132.7, 243.9, 356.4, null],
  [133.2, 243.9, 356.6, null],
  [132.7, 243.7, 356.0, null],
  [133.5, 243.5, 356.1, null],
  [133.3, 244.1, 356.6, null],
  [133.5, 244.1, 356.9, null],
  [135.1, 243.7, 356.9, null],
  [134.2, 243.8, 357.0, null],
  [135.4, 244.9, 357.2, null],
  [135.0, 244.9, 357.2, null],
  [135.4, 244.0, 356.7, null],
  [135.0, 244.7, 357.4, null],
  [134.2, 244.7, 357.4, null],
  [135.7, 244.9, 357.6, null],
  [135.0, 245.0, 357.7, null],
  [136.7, 245.0, 357.8, null],
  [135.3, 245.0, 357.7, null],
  [137.0, 245.1, 358.1, null],
  [136.5, 245.3, 358.0, null],
  [137.6, 245.4, 358.0, null],
  [136.7, 245.4, 358.1, null],
  [137.6, 245.4, 358.1, null],
  [136.9, 245.3, 358.4, null],
  [137.9, 245.2, 357.7, null],
  [135.7, 245.2, 358.4, null],
  [136.5, 245.2, 358.6, null],
  [138.1, 245.4, 358.5, null],
  [138.5, 245.3, 358.5, null],
  [138.5, 245.5, 358.3, null],
  [138.8, 246.1, 358.8, null],
  [139.9, 246.1, 358.8, null],
  [139.3, 246.3, 358.3, null],
  [140.0, 246.8, 358.9, null],
  [140.0, 245.7, 359.0, null],
  [139.7, 246.4, 358.8, null],
  [139.5, 246.2, 359.1, null],
  [141.0, 246.6, 359.3, null],
  [140.8, 246.6, 359.3, null],
  [141.1, 246.8, 359.4, null],
  [140.6, 246.7, 359.4, null],
  [142.1, 246.9, 359.5, null],
  [142.1, 246.9, 359.7, null],
  [142.0, 246.6, 359.0, null],
  [141.5, 247.0, 359.7, null],
  [142.4, 246.5, 359.9, null],
  [141.9, 247.5, 359.7, null],
  [141.6, 246.6, 359.9, null],
  [141.1, 247.7, 360.0, null],
  [142.9, 247.9, 360.1, null],
  [143.0, 247.0, 359.8, null],
  [143.5, 247.3, 359.5, null],
  [142.3, 247.7, 360.3, null],
  [142.9, 247.9, 360.4, null],
  [143.3, 247.9, 360.3, null],
  [145.3, 247.6, 360.4, null],
  [143.8, 248.0, 360.3, null],
  [144.4, 248.1, 360.5, null],
  [144.9, 248.3, 360.7, null],
  [145.6, 248.2, 360.7, null],
  [144.6, 248.5, 360.7, null],
  [145.4, 248.2, 360.9, null],
  [146.3, 248.7, 360.9, null],
  [145.2, 248.6, 361.1, null],
  [145.8, 249.3, 361.0, null],
  [146.1, 249.0, 361.1, null],
  [147.1, 249.5, 360.9, null],
  [148.4, 249.1, 361.1, null],
  [146.5, 249.7, 361.2, null],
  [147.6, 248.8, 361.4, null],
  [146.6, 249.5, 360.8, null],
  [146.2, 249.6, 361.3, null],
  [148.0, 250.0, 361.5, null],
  [148.1, 249.9, 360.9, null],
  [148.7, 249.7, 361.4, null],
  [147.8, 250.3, 360.8, null],
  [147.6, 250.0, 361.1, null],
  [147.0, 250.6, 361.6, null],
  [149.3, 250.2, 362.3, null],
  [150.0, 250.3, 361.8, null],
  [149.7, 250.2, 361.9, null],
  [150.1, 250.5, 362.1, null],
  [150.7, 250.5, 362.0, null],
  [150.6, 250.6, 362.8, null],
  [150.4, 250.7, 362.2, null],
  [151.1, 250.4, 362.2, null],
  [149.3, 251.0, 362.2, null],
  [152.3, 251.0, 362.6, null],
  [151.2, 251.5, 362.6, null],
  [152.0, 251.3, 362.6, null],
  [151.1, 251.5, 362.7, null],
  [152.9, 252.0, 362.5, null],
  [152.3, 250.9, 362.8, null],
  [152.4, 251.3, 362.7, null],
  [153.1, 252.0, 362.1, null],
  [152.8, 252.0, 362.5, null],
  [153.5, 252.0, 362.9, null],
  [154.0, 251.6, 363.0, null],
  [153.4, 252.7, 363.2, null],
  [154.7, 251.6, 363.2, null],
  [154.9, 252.4, 363.3, null],
  [152.7, 252.4, 363.3, null],
  [154.9, 252.9, 363.2, null],
  [154.6, 252.4, 363.4, null],
  [156.0, 252.5, 363.4, null],
  [154.5, 252.8, 363.6, null],
  [155.9, 252.3, 363.6, null],
  [155.7, 252.9, 363.5, null],
  [156.4, 252.9, 363.7, null],
  [154.6, 252.9, 363.6, null],
  [155.9, 253.2, 363.9, null],
  [156.7, 253.1, 363.2, null],
  [158.1, 253.4, 363.2, null],
  [155.8, 253.5, 364.0, null],
  [157.2, 254.0, 364.1, null],
  [157.3, 253.3, 363.8, null],
  [158.1, 253.6, 364.3, null],
  [158.7, 253.8, 364.2, null],
  [157.2, 253.8, 364.1, null],
  [158.6, 254.5, 364.4, null],
  [159.6, 254.4, 364.4, null],
  [159.1, 253.8, 364.4, null],
  [159.9, 254.3, 364.3, null],
  [159.5, 253.7, 364.5, null],
  [159.1, 254.2, 364.3, null],
  [159.8, 254.8, 364.4, null],
  [158.9, 254.1, 364.6, null],
  [160.7, 254.5, 364.5, null],
  [161.2, 254.2, 364.4, null],
  [159.4, 255.1, 364.1, null],
  [161.5, 255.3, 364.9, null],
  [160.3, 255.0, 364.8, null],
  [160.4, 255.1, 364.9, null],
  [163.4, 255.3, 364.9, null],
  [162.2, 255.1, 365.0, null],
  [162.8, 255.2, 364.9, null],
  [161.6, 255.4, 365.1, null],
  [162.3, 255.3, 365.1, null],
  [162.6, 255.4, 365.0, null],
  [164.1, 254.9, 365.4, null],
  [164.3, 255.7, 365.1, null],
  [163.7, 255.8, 365.2, null],
  [162.4, 255.9, 365.0, null],
  [163.1, 255.6, 365.1, null],
  [162.6, 256.2, 365.2, null],
  [163.1, 255.9, 365.1, null],
  [166.5, 256.2, 365.3, null],
  [164.8, 256.2, 365.5, null],
  [164.9, 256.9, 365.5, null],
  [165.9, 257.1, 365.4, null],
  [165.3, 256.8, 365.5, null],
  [166.3, 256.4, 365.5, null],
  [165.7, 257.3, 365.5, null],
  [164.8, 257.1, 365.7, null],
  [166.6, 256.8, 365.6, null],
  [167.0, 257.3, 365.7, null],
  [166.3, 257.6, 366.0, null],
  [167.3, 257.8, 365.9, null],
  [166.6, 257.4, 365.9, null],
  [167.4, 257.3, 365.8, null],
  [169.0, 256.9, 366.0, null],
  [168.2, 257.5, 366.2, null],
  [167.2, 257.8, 365.9, null],
  [168.3, 257.8, 366.4, null],
  [167.1, 258.2, 366.0, null],
  [168.1, 257.9, 366.5, null],
  [169.1, 258.3, 366.4, null],
  [169.0, 258.1, 366.3, null],
  [168.6, 257.9, 366.2, null],
  [170.0, 258.3, 366.2, null],
  [170.4, 258.4, 366.4, null],
  [170.8, 259.0, 366.2, null],
  [171.0, 258.5, 366.2, null],
  [171.5, 258.6, 366.6, null],
  [169.5, 259.4, 366.5, null],
  [170.4, 259.3, 366.2, null],
  [171.4, 259.5, 366.4, null],
  [171.3, 259.1, 366.7, null],
  [171.9, 259.1, 366.7, null],
  [173.4, 258.7, 366.7, null],
  [172.3, 260.1, 366.7, null],
  [172.4, 260.1, 366.7, null],
  [173.1, 260.2, 366.5, null],
  [173.5, 259.7, 366.8, null],
  [172.1, 259.7, 366.2, null],
  [172.8, 259.7, 367.0, null],
  [173.6, 260.5, 366.7, null],
  [173.2, 260.9, 366.4, null],
  [174.9, 260.3, 366.1, null],
  [175.1, 260.9, 365.7, null],
  [175.7, 262.4, 365.9, null],
  [175.4, 262.7, 366.0, null],
  [173.6, 262.9, 365.6, null],
  [175.4, 262.8, 365.4, null],
  [176.2, 263.6, 365.3, null],
  [176.1, 263.9, 365.3, null],
  [176.7, 264.3, 365.4, null],
  [176.6, 264.7, 364.5, null],
  [177.1, 265.6, 365.0, null],
  [176.1, 265.3, 364.9, null],
  [176.5, 265.9, 364.9, null],
  [177.5, 266.3, 364.9, null],
  [178.1, 266.5, 364.8, null],
  [177.8, 266.9, 364.8, null],
  [177.3, 267.3, 364.8, null],
  [178.5, 267.7, 364.7, null],
  [178.9, 267.7, 364.7, null],
  [178.5, 268.5, 364.6, null],
  [179.6, 269.1, 364.6, null],
  [179.1, 269.5, 364.6, null],
  [178.8, 269.4, 364.6, null],
  [179.8, 269.2, 364.5, null],
  [179.1, 269.3, 364.2, null],
  [179.9, 270.5, 364.7, null],
  [181.5, 270.9, 364.6, null],
  [179.1, 270.7, 364.5, null],
  [179.7, 271.6, 364.5, null],
  [181.0, 271.6, 364.5, null],
  [180.8, 271.1, 364.7, null],
  [182.1, 271.5, 364.8, null],
  [181.7, 271.9, 364.5, null],
  [180.7, 272.5, 364.5, null],
  [182.7, 272.0, 364.6, null],
  [182.9, 273.4, 364.9, null],
  [182.6, 272.9, 365.0, null],
  [182.9, 273.1, 365.0, null],
  [184.7, 273.0, 364.9, null],
  [183.3, 273.7, 364.8, null],
  [183.0, 274.5, 365.5, null],
  [183.3, 274.5, 365.1, null],
  [183.8, 274.1, 364.8, null],
  [184.5, 274.3, 364.9, null],
  [185.2, 274.7, 365.0, null],
  [184.0, 274.8, 365.0, null],
  [186.0, 274.9, 365.4, null],
  [186.3, 275.4, 365.1, null],
  [184.6, 275.4, 365.2, null],
  [185.3, 275.8, 365.3, null],
  [185.2, 276.0, 365.3, null],
  [186.3, 275.9, 365.3, null],
  [185.9, 276.4, 365.3, null],
  [187.9, 276.7, 365.4, null],
  [186.1, 277.0, 365.5, null],
  [186.9, 277.2, 365.5, null],
  [186.8, 277.9, 365.5, null],
  [188.8, 277.6, 365.6, null],
  [187.3, 278.2, 365.4, null],
  [187.0, 277.5, 365.7, null],
  [190.1, 278.0, 365.7, null],
  [188.5, 278.4, 365.4, null],
  [188.6, 278.7, 365.7, null],
  [188.2, 279.1, 365.8, null],
  [188.7, 279.3, 365.8, null],
  [189.6, 278.6, 366.2, null],
  [189.9, 279.3, 365.7, null],
  [188.4, 279.9, 365.7, null],
  [190.1, 280.1, 365.7, null],
  [190.9, 279.9, 365.8, null],
  [189.8, 280.5, 365.9, null],
  [191.6, 280.5, 365.9, null],
  [190.3, 280.1, 365.8, null],
  [190.7, 280.0, 366.0, null],
  [191.9, 280.7, 365.7, null],
  [191.8, 280.3, 365.8, null],
  [192.8, 281.0, 365.9, null],
  [191.8, 281.2, 365.9, null],
  [192.0, 281.7, 366.1, null],
  [193.1, 281.0, 366.0, null],
  [191.9, 281.1, 365.9, null],
  [191.4, 281.5, 366.1, null],
  [193.2, 281.7, 365.6, null],
  [193.1, 281.9, 366.2, null],
  [193.0, 282.1, 366.3, null],
  [195.0, 282.3, 365.9, null],
  [193.9, 282.4, 366.3, null],
  [193.2, 283.1, 366.7, null],
  [194.9, 283.0, 365.9, null],
  [193.7, 282.3, 365.5, null],
  [195.8, 283.3, 366.1, null],
  [194.9, 283.1, 366.1, null],
  [195.9, 282.9, 365.9, null],
  [194.6, 283.1, 365.8, null],
  [195.9, 283.8, 365.9, null],
  [197.0, 283.1, 366.1, null],
  [196.1, 283.9, 366.0, null],
  [195.6, 283.0, 365.6, null],
  [196.9, 283.5, 366.5, null],
  [196.9, 284.5, 366.0, null],
  [197.0, 284.6, 365.9, null],
  [197.0, 284.3, 366.0, null],
  [197.3, 284.1, 365.7, null],
  [197.5, 284.9, 366.0, null],
  [197.3, 284.5, 365.6, null],
  [198.0, 284.9, 366.0, null],
  [198.8, 284.7, 365.8, null],
  [199.4, 285.3, 365.9, null],
  [199.6, 284.7, 365.7, null],
  [200.1, 284.9, 365.8, null],
  [198.4, 285.4, 365.6, null],
  [200.1, 285.2, 365.5, null],
  [201.1, 285.9, 365.8, null],
  [200.3, 285.6, 366.0, null],
  [200.5, 286.0, 366.1, null],
  [199.9, 285.4, 365.9, null],
  [200.9, 286.1, 366.0, null],
  [201.3, 286.2, 365.9, null],
  [200.8, 285.7, 366.1, null],
  [202.5, 286.0, 366.1, null],
  [202.0, 286.0, 365.9, null],
  [202.2, 286.6, 366.1, null],
  [201.3, 286.2, 365.6, null],
  [204.6, 286.9, 365.1, null],
  [202.2, 286.9, 364.9, null],
  [202.6, 287.0, 364.5, null],
  [202.7, 287.6, 364.0, null],
  [204.5, 287.7, 364.0, null],
  [204.9, 287.5, 363.5, null],
  [203.7, 288.3, 363.3, null],
  [204.8, 289.1, 363.0, null],
  [203.9, 288.8, 362.5, null],
  [204.6, 288.6, 362.5, null],
  [204.7, 289.9, 362.2, null],
  [203.6, 289.5, 362.0, null],
  [206.0, 289.9, 361.6, null],
  [205.6, 290.2, 361.4, null],
  [208.4, 290.5, 361.3, null],
  [205.4, 290.7, 361.2, null],
  [205.9, 290.7, 360.6, null],
  [205.6, 290.8, 361.0, null],
  [206.5, 291.0, 360.0, null],
  [206.3, 291.7, 360.1, null],
  [207.9, 291.1, 359.8, null],
  [207.4, 291.7, 359.5, null],
  [207.3, 292.2, 359.3, null],
  [206.6, 292.2, 359.7, null],
  [207.5, 292.3, 359.1, null],
  [208.0, 292.6, 359.3, null],
  [208.8, 292.9, 358.8, null],
  [207.5, 292.3, 358.3, null],
  [209.1, 293.3, 358.4, null],
  [210.3, 293.3, 358.2, null],
  [208.9, 293.4, 357.9, null],
  [208.9, 293.3, 357.9, null],
  [210.7, 293.8, 357.6, null],
  [209.4, 294.5, 357.7, null],
  [210.1, 294.3, 357.5, null],
  [209.7, 293.8, 357.4, null],
  [210.9, 295.0, 357.3, null],
  [210.3, 294.6, 357.3, null],
  [211.0, 294.8, 357.0, null],
  [210.1, 295.0, 356.8, null],
  [212.8, 295.2, 356.7, null],
  [213.0, 295.3, 356.6, null],
  [211.6, 295.4, 356.6, null],
  [211.0, 295.4, 356.4, null],
  [213.4, 296.1, 356.1, null],
  [212.4, 296.1, 356.5, null],
  [212.8, 295.7, 356.3, null],
  [213.6, 295.9, 355.8, null],
  [213.6, 295.3, 355.9, null],
  [214.8, 295.8, 355.8, null],
  [214.8, 295.2, 355.8, null],
  [212.8, 295.1, 356.1, null],
  [214.5, 295.5, 355.5, null],
  [213.8, 294.6, 355.6, null],
  [213.7, 294.1, 354.9, null],
  [214.1, 294.5, 355.5, null],
  [214.2, 294.2, 356.0, null],
  [215.2, 294.1, 355.5, null],
  [215.3, 294.0, 355.2, null],
  [215.3, 293.8, 355.3, null],
  [217.4, 293.6, 355.0, null],
  [217.1, 293.6, 354.9, null],
  [215.3, 293.8, 355.3, null],
  [215.8, 293.2, 355.1, null],
  [217.1, 293.3, 355.2, null],
  [216.4, 293.2, 355.3, null],
  [217.2, 293.4, 355.5, null],
  [217.2, 292.6, 354.8, null],
  [219.6, 292.4, 354.8, null],
  [216.6, 291.7, 354.8, null],
  [216.7, 292.4, 354.7, null],
  [219.0, 292.4, 354.8, null],
  [219.0, 292.1, 355.1, null],
  [218.9, 291.7, 354.7, null],
  [219.2, 291.6, 354.4, null],
  [219.0, 291.4, 354.6, null],
  [219.8, 290.8, 354.6, null],
  [217.9, 290.9, 354.5, null],
  [219.5, 290.8, 354.9, null],
  [219.8, 290.7, 354.7, null],
  [220.5, 290.5, 354.9, null],
  [221.1, 290.2, 355.1, null],
  [220.7, 290.1, 354.4, null],
  [220.2, 290.1, 354.7, null],
  [220.8, 289.6, 354.4, null],
  [221.2, 289.7, 354.7, null],
  [221.2, 289.7, 354.8, null],
  [222.2, 289.4, 354.7, null],
  [223.3, 289.5, 354.6, null],
  [220.8, 289.0, 354.6, null],
  [221.3, 289.4, 355.3, null],
  [221.5, 288.6, 354.7, null],
  [221.1, 288.6, 354.2, null],
  [222.8, 288.9, 354.7, null],
  [221.6, 288.0, 354.7, null],
  [224.0, 287.9, 354.4, null],
  [223.3, 287.9, 354.5, null],
  [223.6, 287.8, 354.7, null],
  [224.6, 287.3, 354.6, null],
  [223.6, 287.3, 354.9, null],
  [223.0, 287.5, 354.7, null],
  [223.7, 287.4, 354.5, null],
  [225.8, 286.9, 354.9, null],
  [223.4, 286.3, 355.0, null],
  [224.8, 286.6, 354.3, null],
  [225.9, 286.5, 354.6, null],
  [225.3, 286.2, 354.5, null],
  [224.6, 286.0, 354.9, null],
  [226.2, 286.0, 354.5, null],
  [227.6, 285.7, 354.6, null],
  [226.0, 285.7, 354.2, null],
  [226.0, 285.3, 354.7, null],
  [227.5, 285.4, 354.5, null],
  [227.4, 285.0, 355.0, null],
  [225.0, 285.0, 354.2, null],
  [228.0, 284.7, 354.6, null],
  [226.5, 284.6, 354.5, null],
  [225.0, 284.4, 353.7, null],
  [226.8, 284.1, 354.6, null],
  [226.1, 284.1, 354.6, null],
  [228.0, 284.0, 354.3, null],
  [229.0, 283.9, 354.3, null],
  [228.9, 283.6, 354.5, null],
  [228.7, 284.0, 354.9, null],
  [230.0, 283.4, 354.7, null],
  [228.8, 283.2, 354.6, null],
  [228.9, 282.9, 354.9, null],
  [229.5, 282.9, 355.1, null],
  [230.0, 282.4, 355.6, null],
  [229.0, 281.9, 355.8, null],
  [229.6, 281.4, 355.6, null],
  [230.1, 281.3, 356.1, null],
  [229.9, 280.8, 354.9, null],
  [230.4, 280.6, 354.0, null],
  [230.2, 280.8, 353.7, null],
  [231.1, 280.0, 352.3, null],
  [230.9, 280.3, 350.9, null],
  [231.2, 280.3, 350.1, null],
  [231.6, 279.6, 349.3, null],
  [229.8, 279.7, 348.4, null],
  [232.0, 279.7, 346.6, null],
  [231.3, 279.5, 345.7, null],
  [230.9, 279.2, 344.7, null],
  [231.3, 278.9, 343.6, null],
  [230.8, 279.0, 342.9, null],
  [232.2, 278.6, 342.1, null],
  [233.1, 278.5, 340.4, null],
  [231.5, 277.7, 339.5, null],
  [231.5, 277.6, 339.3, null],
  [232.3, 277.6, 338.1, null],
  [231.4, 277.3, 337.7, null],
  [231.6, 277.5, 336.7, null],
  [230.6, 277.2, 335.7, null],
  [232.5, 276.8, 335.4, null],
  [231.8, 276.9, 334.5, null],
  [232.5, 276.7, 333.3, null],
  [233.8, 276.6, 332.9, null],
  [232.3, 276.0, 332.0, null],
  [232.6, 275.9, 331.1, null],
  [232.6, 275.8, 330.8, null],
  [232.6, 275.1, 330.5, null],
  [232.4, 275.4, 329.8, null],
  [231.5, 274.9, 328.6, null],
  [232.5, 275.0, 328.6, null],
  [232.8, 274.8, 327.7, null],
  [231.2, 273.9, 327.0, null],
  [231.6, 273.7, 326.7, null],
  [232.8, 273.9, 326.1, null],
  [231.9, 273.1, 325.6, null],
  [232.2, 273.3, 325.1, null],
  [231.8, 272.9, 324.7, null],
  [232.2, 272.8, 323.9, null],
  [232.3, 272.3, 324.0, null],
  [230.5, 272.2, 323.7, null],
  [231.6, 272.0, 322.8, null],
  [230.1, 271.6, 322.6, null],
  [233.0, 271.6, 322.4, null],
  [231.2, 271.4, 321.9, null],
  [230.9, 271.1, 321.4, null],
  [231.8, 271.0, 321.2, null],
  [231.8, 271.2, 320.7, null],
  [231.3, 270.7, 320.0, null],
  [230.9, 270.4, 319.9, null],
  [230.5, 270.2, 319.5, null],
  [231.5, 270.3, 319.4, null],
  [229.7, 270.0, 319.0, null],
  [230.7, 269.0, 318.8, null],
  [230.2, 269.2, 318.3, null],
  [230.0, 269.4, 318.2, null],
  [230.3, 269.2, 318.0, null],
  [231.5, 268.9, 317.7, null],
  [230.8, 268.4, 318.0, null],
  [232.0, 268.2, 317.3, null],
  [231.9, 268.5, 317.2, null],
  [230.7, 268.1, 316.7, null],
  [229.8, 267.6, 317.2, null],
  [231.5, 267.6, 316.9, null],
  [230.7, 267.2, 316.4, null],
  [232.1, 267.3, 316.4, null],
  [232.9, 266.8, 316.1, null],
  [229.9, 266.9, 315.6, null],
  [229.9, 266.9, 316.2, null],
  [231.0, 266.0, 316.1, null],
  [230.9, 266.6, 315.6, null],
  [233.1, 265.8, 315.4, null],
  [231.0, 265.7, 315.1, null],
  [231.5, 265.4, 315.1, null],
  [229.7, 265.4, 315.4, null],
  [228.5, 265.0, 314.8, null],
  [229.0, 265.4, 314.9, null],
  [231.7, 264.9, 314.8, null],
  [229.2, 265.1, 314.9, null],
  [230.7, 264.6, 314.7, null],
  [231.8, 264.8, 314.9, null],
  [229.8, 264.1, 314.6, null],
  [229.6, 264.1, 314.3, null],
  [230.8, 264.1, 314.7, null],
  [229.5, 263.7, 314.7, null],
  [231.0, 264.0, 314.7, null],
  [229.7, 263.5, 314.7, null],
  [229.4, 263.6, 314.4, null],
  [230.7, 263.5, 314.1, null],
  [229.5, 262.9, 314.3, null],
  [230.2, 262.5, 314.2, null],
  [228.8, 262.2, 314.6, null],
  [229.1, 262.2, 314.4, null],
  [230.5, 262.1, 314.7, null],
  [228.6, 262.0, 314.2, null],
  [229.0, 261.8, 314.7, null],
  [228.4, 261.5, 314.6, null],
  [229.1, 261.5, 314.2, null],
  [230.1, 261.2, 314.4, null],
  [228.3, 261.7, 314.7, null],
  [230.4, 261.0, 314.8, null],
  [229.2, 261.1, 314.7, null],
  [230.3, 261.3, 314.4, null],
  [227.4, 260.4, 314.7, null],
  [228.9, 260.4, 314.4, null],
  [229.6, 260.5, 314.9, null],
  [228.2, 259.9, 314.9, null],
  [226.4, 260.3, 315.0, null],
  [228.6, 259.9, 314.8, null],
  [228.9, 259.3, 315.0, null],
  [229.2, 259.5, 315.1, null],
  [228.5, 259.6, 315.1, null],
  [228.9, 259.4, 315.1, null],
  [227.5, 258.8, 314.7, null],
  [227.5, 259.1, 315.2, null],
  [229.1, 258.8, 315.1, null],
  [229.3, 258.9, 315.6, null],
  [228.4, 258.7, 315.2, null],
  [228.4, 258.7, 315.3, null],
  [228.5, 258.5, 315.6, null],
  [228.6, 258.4, 316.0, null],
  [228.1, 258.4, 316.0, null],
  [227.3, 258.2, 315.9, null],
  [228.2, 257.7, 315.9, null],
  [224.9, 258.3, 316.1, null],
  [227.4, 258.2, 316.1, null],
  [225.6, 257.6, 316.6, null],
  [228.7, 257.6, 316.3, null],
  [227.9, 257.4, 316.5, null],
  [229.4, 257.1, 316.9, null],
  [229.3, 257.3, 316.7, null],
  [227.6, 256.8, 316.8, null],
  [227.9, 256.9, 317.2, null]
];
